import React, { useState, useEffect } from 'react';
import axios from 'axios';
import axiosInstance, { weburl } from '../../../axiosInstance'; import { Link, useNavigate, useParams } from 'react-router-dom';
import Sidebar from '../../components/Sidebar';
import Navbar from '../../components/Navbar';
import toast from 'react-hot-toast';
import { Button } from 'bootstrap/dist/js/bootstrap.bundle.min';
import { event } from 'jquery';
import getDecryptData from '../../../helpers/getDecryptData';
import Select from 'react-select';
import { triggerChooseimg } from "../../components/ChooseImg";
import Gallery from "../../components/Gallery";

const OrderEdit = () => {

    const decryptdatajson = getDecryptData();
  
  const navigate = useNavigate();

  const [AllProducts, setAllProducts] = useState([]);

  const getUserAllPro = async () => {
    try {
        const response = await axiosInstance.get(`/all-products?type=1`);

        setAllProducts(response.data.products);
        console.log('setAllProducts', response.data.products)

    } catch (error) {
        console.error('Error fetching user products:', error);
    } 
};



  const [AllUser, setAllUser] = useState([]);
  const [AddProduct, setAddProduct] = useState([]);

  const [AddRental, setAddRental] = useState([]);
  const [AddReceived, setAddReceived] = useState([]);
  const [AddReturn, setAddReturn] = useState([]);
  const [addHistory, setAddHistory] = useState([]);
  const [OldHistory, setOldHistory] = useState({});

  


  const [UserId, setUserId] = useState(null);
  const [AllEmployee, setAllEmployee] = useState([]);

  const [AllSaleEmployee, setAllSaleEmployee] = useState([]);


  const [UserDetails, setUserDetails] = useState({});

  
  const [OrderId, setOrderId] = useState(null);


  // Utility function to convert ISO date string to YYYY-MM-DD format
const formatDate = (isoDateString) => {
  const dateObj = new Date(isoDateString);

  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
  const day = String(dateObj.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};

    const [formData, setFormData] = useState({
          PickupDate: '',
    ReturnDate: ''
    });
  
    const [subtotal, setSubtotal] = useState(0);
    const [discount, setDiscount] = useState(0); // Default discount is 0
    const [shipping, setShipping] = useState(0); // Default discount is 0
    const [finalTotal, setFinalTotal] = useState(0);
    const [taxTotal, setTaxTotal] = useState(0);

    const [applyIGST, setApplyIGST] = useState(false);
    const [applyCGST, setApplyCGST] = useState(false);
    const [applySGST, setApplySGST] = useState(false);

    const handleClearClick = () => {
      setSearchQuery("");
    };

    const handleDiscountChange = (e) => {
      const value = parseFloat(e.target.value) || 0;
      setDiscount(value);
    };

    const handleShippingChange = (e) => {
      const value = parseFloat(e.target.value) || 0;
      setShipping(value);
    };
    
    const handleAddProduct = (product) => {
      const now = new Date();
      const timeStamp = now.toISOString(); // e.g., 2025-05-01T10:10:30.000Z

      if (formData.order  === 1 && product.stock <= 0) {
        toast.error('Product is out of stock');
        return null;  // Early return to prevent adding the product
      }else if( product.reStock <= 0){
                    toast.error('Product is out of stock');
                    return null;  
                  }

       console.log('ProductProduct',product.reStock)
      let ProductCost = 0;
      // if(formData.diffDays && formData.diffDays > 0){
      //  if(formData.diffDays < 8){
      //   ProductCost = product.oneto7 ? product.oneto7 : product.salePrice ;
      //  }else if(formData.diffDays < 15){
      //   ProductCost = product.eightto14 ? product.eightto14 : product.salePrice ;
      //  }else if(formData.diffDays < 30){
      //   ProductCost = product.fivto30 ? product.fivto30 : product.salePrice ;
      //  }else if(formData.diffDays < 90){
      //   ProductCost = product.monthto3month ? product.monthto3month : product.salePrice ;
      //  }else if(formData.diffDays < 180){
      //   ProductCost = product.threemonthto6month ? product.threemonthto6month : product.salePrice ;
      //  }else{
      //   ProductCost = product.salePrice;
      //  }
      //  ProductCost = formData.diffDays * ProductCost;
      // }
      console.log('ProductCost',ProductCost);
      console.log('formData.diffDays',formData.diffDays);

      const updatedProduct = {
        ...product,
        quantity: 1,
        amount: ProductCost,
        total: ProductCost,
        history : timeStamp,
        tax: id === '1' ? product.gst : product.Rentalgst || 0 ,
       };
      setAddProduct([...AddProduct, updatedProduct]);
      SubmitHistory(`Add Product`, `product : ${product.title}`)

      setSearchQuery("");
      console.log('Rentaltax')
    };

    
      const handleAddRental = () => {
        const now = new Date();
        const timeStamp = now.toISOString(); // e.g., 2025-05-01T10:10:30.000Z 
        
              if( !formData.raMethod ){
            
              if(!formData.raDate){
                toast.error('Date is required')
              } else if(!formData.raTime){
                toast.error('Time is required')
              }else if(!formData.raAmount){
                toast.error('Amount is required')
              } else if(!formData.raMethod){
                toast.error('Payment method is required')
              }
            return null;
            }
              const updatedData = {
                date: formData.raDate,
                time: formData.raTime,
                gateway: formData.raGateway,
                amount: formData.raAmount,
                method: formData.raMethod,
                transaction: formData.raTransaction,
                comment: formData.raComment,
                checkNo: formData.raCheckNo,
                bankName: formData.raBankName,
                chequeAmount: formData.raChequeAmount,
                chequeDate: formData.raChequeDate,  
                authSignatoryName: formData.raAuthSignatoryName,
                history : timeStamp,
              };
        
              setAddRental([...AddRental, updatedData]);
              setFormData((prevData) => ({
                ...prevData,
                raDate: '',
                raTime: '',
                raGateway: '',
                raAmount: '',
                raMethod: '',
                raTransaction: '',
                raComment: '',
                raCheckNo: '',
                raBankName: '',
                raChequeAmount: '',
                raChequeDate: '',
                raAuthSignatoryName: '',
              }));
              SubmitHistory('Add Rental', 'None')

            }
        
            const handleAddReceived = () => {
              if( !formData.raMethod ){
            
              if(!formData.raDate){
                toast.error('Date is required')
              } else if(!formData.raTime){
                toast.error('Time is required')
              }else if(!formData.raAmount){
                toast.error('Amount is required')
              }else if(!formData.raMethod){
                toast.error('Payment method is required')
              }
            return null;
            }
              const updatedData = {
                days: formData.days || 'NA',
                date: formData.raDate,
                time: formData.raTime,
                gateway: formData.raGateway,
                amount: formData.raAmount,
                method: formData.raMethod,
                transaction: formData.raTransaction,
                comment: formData.raComment,
                checkNo: formData.raCheckNo,
                bankName: formData.raBankName,
                chequeAmount: formData.raChequeAmount,
                chequeDate: formData.raChequeDate,  
                authSignatoryName: formData.raAuthSignatoryName,
              };

              if (formData.days) {
  const pickupDate = new Date(formData.PickupDate);
  const returnDate = new Date(formData.ReturnDate);
  const diffTime = returnDate - pickupDate;
  const diffDays = diffTime / (1000 * 3600 * 24);

  const extraDays = Number(formData.days);
  const totalDays = diffDays + extraDays + 1;

  console.log('Base diffDays: ' + diffDays);
  console.log('Extra days: ' + extraDays);
  console.log('Total days: ' + totalDays);

  const returnValue = addDaysToDate(formData.PickupDate, totalDays);

  setFormData((prevData) => ({
    ...prevData,
    ReturnDate: returnValue,
    diffDays: totalDays,
  }));

  toast.error('Updated ReturnDate: ' + returnValue);
}


              setAddReceived([...AddReceived, updatedData]);
              setFormData((prevData) => ({
                ...prevData,
                raDate: '',
                raTime: '',
                raGateway: '',
                raAmount: '',
                raMethod: '',
                raTransaction: '',
                raComment: '',
                raCheckNo: '',
                raBankName: '',
                raChequeAmount: '',
                raChequeDate: '',
                raAuthSignatoryName: '',
              }));
              SubmitHistory(formData.order === 4 ? 'Add Payment Mangement' : 'Add Security Amount Received'  , 'None')

            }
        
            const handleAddReturn = () => {
              if( !formData.raMethod ){
            
              if(!formData.raDate){
                toast.error('Date is required')
              } else if(!formData.raTime){
                toast.error('Time is required')
              }else if(!formData.raAmount){
                toast.error('Amount is required')
              }else if(!formData.raMethod){
                toast.error('Payment method is required')
              }
            return null;
            }
              const updatedData = {
                date: formData.raDate,
                time: formData.raTime,
                gateway: formData.raGateway,
                amount: formData.raAmount,
                method: formData.raMethod,
                transaction: formData.raTransaction,
                comment: formData.raComment,
                checkNo: formData.raCheckNo,
                bankName: formData.raBankName,
                chequeAmount: formData.raChequeAmount,
                chequeDate: formData.raChequeDate,  
                authSignatoryName: formData.raAuthSignatoryName,
              };
        
              setAddReturn([...AddReturn, updatedData]);
              setFormData((prevData) => ({
                ...prevData,
                raDate: '',
                raTime: '',
                raGateway: '',
                raAmount: '',
                raMethod: '',
                raTransaction: '',
                raComment: '',
                raCheckNo: '',
                raBankName: '',
                raChequeAmount: '',
                raChequeDate: '',
                raAuthSignatoryName: '',
                days: '',
              }));
              SubmitHistory('Add Security Amount Return', 'None');
            }
            
            const handleEditRental = (index) => {
              const selectedData = AddRental[index];
            
              setFormData((prevData) => ({
                ...prevData,
                raDate: selectedData.date || '',
                raTime: selectedData.time || '',
                raGateway: selectedData.gateway || '',
                raAmount: selectedData.amount || '',
                raMethod: selectedData.method || '',
                raTransaction: selectedData.transaction || '',
                raComment: selectedData.comment || '',
                raCheckNo: selectedData.checkNo || '',
                raBankName: selectedData.bankName || '',
                raChequeAmount: selectedData.chequeAmount || '',
                raChequeDate: selectedData.chequeDate || '',
                raAuthSignatoryName: selectedData.authSignatoryName || '',
                raindex: index
              }));

            };
        
                
            const handleEditReceived = (index) => {
              const selectedData = AddReceived[index];
            
              setFormData((prevData) => ({
                ...prevData,
                raDate: selectedData.date || '',
                raTime: selectedData.time || '',
                raGateway: selectedData.gateway || '',
                raAmount: selectedData.amount || '',
                raMethod: selectedData.method || '',
                raTransaction: selectedData.transaction || '',
                raComment: selectedData.comment || '',
                raCheckNo: selectedData.checkNo || '',
                raBankName: selectedData.bankName || '',
                raChequeAmount: selectedData.chequeAmount || '',
                raChequeDate: selectedData.chequeDate || '',
                raAuthSignatoryName: selectedData.authSignatoryName || '',
                raindex: index
              }));
            };
        
            const handleEditReturn = (index) => {
              const selectedData = AddReturn[index];
            
              setFormData((prevData) => ({
                ...prevData,
                raDate: selectedData.date || '',
                raTime: selectedData.time || '',
                raGateway: selectedData.gateway || '',
                raAmount: selectedData.amount || '',
                raMethod: selectedData.method || '',
                raTransaction: selectedData.transaction || '',
                raComment: selectedData.comment || '',
                raCheckNo: selectedData.checkNo || '',
                raBankName: selectedData.bankName || '',
                raChequeAmount: selectedData.chequeAmount || '',
                raChequeDate: selectedData.chequeDate || '',
                raAuthSignatoryName: selectedData.authSignatoryName || '',
                raindex: index
              }));
            };
    
  
    const ResetRentalInputs = () => {
      setFormData((prevData) => ({
        ...prevData,
        raDate: '',
        raTime: '',
        raGateway: '',
        raAmount: '',
        raMethod: '',
        raTransaction: '',
        raComment: '',
      }));

    }

  
       const handleUpdateRental = (index) => {
        toast.error('handleUpdateRental')
              if( !formData.raMethod ){
            
                if(!formData.raDate){
                  toast.error('Date is required')
                } else if(!formData.raTime){
                  toast.error('Time is required')
                }else if(!formData.raAmount){
                  toast.error('Amount is required')
                } else if(!formData.raMethod){
                  toast.error('Payment method is required')
                }
              return null;
              }
        
              const updatedData = [...AddRental];
 
               updatedData[index].date = formData.raDate || "NA";
               updatedData[index].time = formData.raTime;
               updatedData[index].gateway = formData.raGateway;
               updatedData[index].amount =  formData.raAmount;
               updatedData[index].method =  formData.raMethod;
               updatedData[index].transaction =  formData.raTransaction || "NA";
               updatedData[index].comment =  formData.raComment; 
               updatedData[index].checkNo =  formData.raCheckNo; 
               updatedData[index].bankName =  formData.raBankName; 
               updatedData[index].chequeAmount =  formData.raChequeAmount; 
               updatedData[index].chequeDate =  formData.raChequeDate; 
               updatedData[index].authSignatoryName =  formData.raAuthSignatoryName; 
               setAddRental(updatedData);
               SubmitHistory('Update Rental Amount'  , 'None');

            }
            
            const handleUpdateReceived = (index) => {
              if( !formData.raMethod ){
            
                if(!formData.raDate){
                  toast.error('Date is required')
                } else if(!formData.raTime){
                  toast.error('Time is required')
                }else if(!formData.raAmount){
                  toast.error('Amount is required')
                }else if(!formData.raMethod){
                  toast.error('Payment method is required')
                }
              return null;
              }
        
              const updatedData = [...AddReceived];
               updatedData[index].days = formData.days;
               updatedData[index].date = formData.raDate;
               updatedData[index].time = formData.raTime;
               updatedData[index].gateway = formData.raGateway;
               updatedData[index].amount =  formData.raAmount;
               updatedData[index].method =  formData.raMethod;
               updatedData[index].transaction =  formData.raTransaction;
               updatedData[index].comment =  formData.raComment; 
               updatedData[index].checkNo =  formData.raCheckNo; 
               updatedData[index].bankName =  formData.raBankName; 
               updatedData[index].chequeAmount =  formData.raChequeAmount; 
               updatedData[index].chequeDate =  formData.raChequeDate; 
               updatedData[index].authSignatoryName =  formData.raAuthSignatoryName; 
               setAddReceived(updatedData);
                SubmitHistory(formData.order === 4 ? 'Update Payment Mangement' : 'Update Security Amount Received'  , 'None');

            }
        
            const handleUpdateReturn = (index) => {
              if( !formData.raMethod ){
            
                if(!formData.raDate){
                  toast.error('Date is required')
                } else if(!formData.raTime){
                  toast.error('Time is required')
                }else if(!formData.raAmount){
                  toast.error('Amount is required')
                }else if(!formData.raMethod){
                  toast.error('Payment method is required')
                }
              return null;
              }
        
              const updatedData = [...AddReturn];
               updatedData[index].date = formData.raDate;
               updatedData[index].time = formData.raTime;
               updatedData[index].gateway = formData.raGateway;
               updatedData[index].amount =  formData.raAmount;
               updatedData[index].method =  formData.raMethod;
               updatedData[index].transaction =  formData.raTransaction;
               updatedData[index].comment =  formData.raComment; 
               updatedData[index].checkNo =  formData.raCheckNo; 
               updatedData[index].bankName =  formData.raBankName; 
               updatedData[index].chequeAmount =  formData.raChequeAmount; 
               updatedData[index].chequeDate =  formData.raChequeDate; 
               updatedData[index].authSignatoryName =  formData.raAuthSignatoryName; 
               setAddReturn(updatedData);
               SubmitHistory('Update Security Amount Return', 'None');

            }



    const handleRemoveRental = (index) => {
      const updatedData = [...AddRental];
      updatedData.splice(index, 1);
      setAddRental(updatedData);
      SubmitHistory('Remove Rental Amount', 'None');

    };


    const handleRemoveReceived = (index) => {
      const updatedData = [...AddReceived];
      updatedData.splice(index, 1);
      setAddReceived(updatedData);
      SubmitHistory('Remove Security Amount Return', 'None');

    };

    const handleRemoveReturn = (index) => {
      const updatedData = [...AddReturn];
      updatedData.splice(index, 1);
      setAddReturn(updatedData);
      SubmitHistory('Remove Security Amount Return', 'None');
    };

    
    const handleRemoveProduct = (index) => {
      const updatedProducts = [...AddProduct];
      updatedProducts.splice(index, 1);
      setAddProduct(updatedProducts);
      SubmitHistory('Remove Product', 'None');
    };
    
    const handleQuantityChange = (index, value) => {
      const updatedProducts = [...AddProduct];
      const quantity = parseInt(value) || 1;
      const price = updatedProducts[index].amount || 0;
      const tax = updatedProducts[index].tax || 0;
    
      updatedProducts[index].quantity = quantity;
      updatedProducts[index].total = quantity * price * (1 + tax / 100);
      setAddProduct(updatedProducts);
      SubmitHistory('Update Product Quantity', 'None');
    };


        const handleTitleChange = (index, value) => {
      const updatedProducts = [...AddProduct];
       const title = value;     
       updatedProducts[index].title = title;
      setAddProduct(updatedProducts);
      // SubmitHistory('Update Product Title', 'None');
    };


    const handleSerialNumberChange = (index, value) => {
      const updatedProducts = [...AddProduct];
      const serialNumber = value; 
      updatedProducts[index].serialNumber = serialNumber;
       setAddProduct(updatedProducts);
    };
    
    const handleAmtChange = (index, value) => {
      const updatedProducts = [...AddProduct];
      const newAmount = parseFloat(value) || 0;
      const quantity = updatedProducts[index].quantity || 1;
      const tax = updatedProducts[index].tax || 0;
    
      updatedProducts[index].amount = newAmount;
      updatedProducts[index].total = quantity * newAmount * (1 + tax / 100);
      setAddProduct(updatedProducts);
      SubmitHistory('Update Product Amount', 'None');

    };

    const handleTaxChange = (index, value) => {
      const updatedProducts = [...AddProduct];
      const tax = parseFloat(value) || 0;
      const quantity = updatedProducts[index].quantity || 1;
      const price = updatedProducts[index].amount || 0;
    
      updatedProducts[index].tax = tax;
      updatedProducts[index].total = quantity * price * (1 + tax / 100);
      setAddProduct(updatedProducts);
      SubmitHistory('Update Product Tax', 'None');
    };

      const [searchQuery, setSearchQuery] = useState("");
    
      const handleInputChange = (e) => {
        setSearchQuery(e.target.value);
      };
    
  const [showSearch, setShowSearch] = useState("false");
  const toggleSearch = () => {
    setShowSearch(!showSearch);
  };

  const filteredProducts = AllProducts.filter((item) =>
    item.title.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleUserChange = (userId) => {
     const selectedUser = AllUser.find((user) => user._id === userId);
     console.log('AllUser',userId, AllUser)

    // if (selectedUser) {
    //   setUserDetails({
    //     id: selectedUser._id,
    //     name: selectedUser.username,
    //     email: selectedUser.email,
    //     phone: selectedUser.phone,
    //   });
    //  }

      setCommentStatus(true);
      setCommentEmployee(selectedUser.username);
      setMyComment('Update User');

    //  SubmitHistory('Update User', `username: ${selectedUser.username}`);

  };
  

       const [commentStatus, setCommentStatus] = useState(false);
       const [commentEmployee, setCommentEmployee] = useState(null);
       const [MyComment, setMyComment] = useState('');


  const handleChangeUserComment = () => {
    if(!formData.formcomment || formData.formcomment === '' ){
      toast.error('Please type comment');
    }else{

     SubmitHistory(`Update User | username : ${commentEmployee} `, `${formData.formcomment}`,formData.employeeId);
     setCommentStatus(false);
        setFormData((prevData) => ({
        ...prevData,
        'formcomment': null,
      }));
    }

  }



  const handleChangeComment_old = () => {
    if(!formData.formcomment || formData.formcomment === '' ){
      toast.error('Please type comment');
    }else{

     SubmitHistory(`${MyComment} | username : ${commentEmployee} `, `${formData.formcomment}`,formData.employeeId);
     setCommentStatus(false);
        setFormData((prevData) => ({
        ...prevData,
        'formcomment': null,
      }));
    }

  }

    
      const handleChangeComment = () => {
        if(!formData.formcomment || formData.formcomment === ''  ){
          toast.error('Please type comment');
        }else{
    
          if( !formData.working || formData.working === '' ){
          toast.error('Please Choose Working Status');
          }else{
        if(!formData.workingdate && formData.working !== '2'){
          toast.error('Please Choose date');
  return null;
        }
          
      SubmitHistory(`${MyComment} | username : ${commentEmployee} `, `${formData.formcomment} - ${formData.working === '1' && 'working' ||  formData.working === '0'  && 'On leave'  ||  formData.working === '2'  && 'Left job'}`,formData.employeeId,formData.working,formData.working === '2' ? 1 : formData.workingdays ,formData.workingdate);
          
      if (formData.workingdays &&  formData.working === '0') {
 
          const pickupDate = new Date(formData.PickupDate);
  const returnDate = new Date(formData.ReturnDate);
  const diffTime = returnDate - pickupDate;
  const diffDays = diffTime / (1000 * 3600 * 24);

  const extraDays = Number(formData.workingdays);
  const totalDays = diffDays + extraDays + 1;

  console.log('Base diffDays: ' + diffDays);
  console.log('Extra days: ' + extraDays);
  console.log('Total days: ' + totalDays);

  const returnValue = addDaysToDate(formData.PickupDate, totalDays);

  setFormData((prevData) => ({
    ...prevData,
    ReturnDate: returnValue,
    diffDays: totalDays,
  }));
  
 
 }

setCommentStatus(false);
            setFormData((prevData) => ({
            ...prevData,
            'formcomment': null,
            'working' : null,
            
          }));
  
          }
     
        }
    
      }
  
  const handleChange = (e) => {
    const { name, value, type, checked,label  } = e.target;

    let newValue = type === "checkbox" ? checked : value;

    if (name === "slug" ) {
      newValue = value
        .toLowerCase() // Convert to lowercase
        .replace(/\s+/g, "-") // Replace spaces with "-"
        .replace(/[^a-z0-9-]/g, ""); // Remove special characters except "-"
    }else if (name === "employeeSaleId" ) {
      newValue = value;
      SubmitHistory('Update Employee Billing', `username : ${label}`);
    } else if (name === "employeeId" ) {
      newValue = value;
      // SubmitHistory('Update Employee ( Doctor / Nurse / Runner )', `username : ${label}`);
      setCommentStatus(true);
      setCommentEmployee(label);
      setMyComment('Update Employee ( Doctor / Nurse / Runner )');
    } 
    
    if(name === 'PickupDate' &&  formData.diffDays){
   
       const dateValue = newValue;
       const returnvalue =  addDaysToDate(dateValue, formData.diffDays);
       console.log('returnvalue',returnvalue);
       console.log('formData.PickupDate, formData.days',formData.PickupDate, formData.diffDays);
       setFormData((prevData) => ({
        ...prevData,
        'ReturnDate': returnvalue,
      }));
      
    }
    
    if (name === "diffDays" ) {
      let myvalue;
      if(1 > newValue ){
        myvalue = 1
      }else{
        myvalue = newValue;
      }

      setFormData((prevData) => ({
        ...prevData,
        [name]: myvalue,
      }));

if(formData.PickupDate){
  const returnvalue =  addDaysToDate(formData.PickupDate, myvalue);
  console.log('returnvalue',returnvalue);
  console.log('formData.PickupDate, formData.days',formData.PickupDate, formData.days);
  setFormData((prevData) => ({
   ...prevData,
   'ReturnDate': returnvalue,
 }));
}
     
     
    }
 
    else{
      setFormData((prevData) => ({
        ...prevData,
        [name]: newValue,
      }));
    }
  

   };


  const handleUserDataChange = (e) => {
    const { name, value, type, checked } = e.target;

    let newValue = type === "checkbox" ? checked : value;

    if (name === "slug" ) {
      newValue = value
        .toLowerCase() // Convert to lowercase
        .replace(/\s+/g, "-") // Replace spaces with "-"
        .replace(/[^a-z0-9-]/g, ""); // Remove special characters except "-"
    }

    setUserDetails((prevData) => ({
      ...prevData,
      [name]: newValue,
    }));
  };
  

// const selectUser = async (OrderId, User,cat,type,distance) => {
//   fetchemployeeData(cat,type,distance);
//   setOrderId(OrderId);
//   setUserId(User);
//  }

const fetchUserData = async () => {

  setAllUser([]);
  try {

    const response = await axiosInstance.get(`/all-employee?&type=2&filter=none`);
    const { success, Users } = response.data;
    if (success) {
      console.log('Users',response.data);

      setAllUser(Users);
     }

  } catch (error) {
    console.error('Error fetching User:', error);

  }

};


const fetchSaleEmployeeData = async () => {

  setAllSaleEmployee([]);
  try {
    const response = await axiosInstance.get(`/all-employee?&type=1&filter=2`);
    const { success, Users } = response.data;
    if (success) {
      console.log('Users',response.data);
      setAllSaleEmployee(Users);
     }

  } catch (error) {
    console.error('Error fetching User:', error);

  }

};

const fetchEmployeeData = async (id) => {

  setAllEmployee([]);
  try {
    const response = await axiosInstance.get(`/all-employee?&type=1&filter=${id}`);
    const { success, Users } = response.data;
    if (success) {
      console.log('Users',response.data);
      setAllEmployee(Users);
     }

  } catch (error) {
    console.error('Error fetching User:', error);

  }

};


   const { id } = useParams();
 
   const [IsLoading, setIsLoading] = useState(true);

  const getUserOrders = async () => {
    setIsLoading(true);  

    try {

       const { data } = await axiosInstance.get(`/admin/get-order/${id}`);

      // if (data?.success) {
      //   console.log('order', data)
      //   setOrder(data?.userOrder); 
      // }

console.log('datasetIsLoading ',data)
const myOrder = data?.Order;
if(myOrder){
// console.log('myOrder',myOrder);

setFormData((prevData) => ({
    ...prevData,
    employeeId:myOrder.employeeId,
    AdvanceAmt:myOrder.AdvanceAmt,
    SecurityAmt:myOrder.SecurityAmt,
    OnBoardDate:formatDate(myOrder.OnBoardDate),
    UserId:myOrder.userId,
    order:myOrder.type,
    employeeSaleId:myOrder.employeeSaleId,
    ReturnDate:formatDate(myOrder.ReturnDate),
    PickupDate:formatDate(myOrder.PickupDate),
    dutyHr:myOrder.dutyHr,
    Ltime:myOrder?.Ltime,
    appoinment:myOrder?.appoinment,
    prescription:myOrder?.prescription,
    images:myOrder?.images,
  })); 
   console.log('formdata', formData.employeeId);
  setUserId(myOrder.userId._id);
  setDiscount(myOrder.discount);
  setShipping(myOrder.shipping);
  setTaxTotal(myOrder.taxTotal);
  setUserDetails(myOrder.UserDetails ? myOrder.UserDetails[0] : {} );
  setAddProduct(myOrder?.addProduct ? myOrder?.addProduct : {});
  setAddReceived(myOrder?.addReceived ? myOrder?.addReceived : {});
  setAddRental(myOrder?.addRental ? myOrder?.addRental : {} );
  setAddReturn(myOrder?.addReturn ? myOrder?.addReturn : {} );
  setAddHistory(myOrder?.addHistory ? myOrder?.addHistory : {} );
  setApplyCGST(myOrder.applyCGST);
  setApplyIGST(myOrder.applyIGST)
  setApplySGST(myOrder.applySGST);
  setSubtotal(myOrder.subtotal);

  setOldHistory( {
      AdvanceAmt : myOrder.AdvanceAmt,
      discount : myOrder.discount,
      SecurityAmt : myOrder.SecurityAmt,
      OnBoardDate : formatDate(myOrder.OnBoardDate),
      order : myOrder.type,
      ReturnDate : formatDate(myOrder.ReturnDate),
      PickupDate : formatDate(myOrder.PickupDate),
      shipping : myOrder.shipping,
      taxTotal : myOrder.taxTotal,
      taxTotal : myOrder.taxTotal,
      UserDetails : myOrder.UserDetails ? myOrder.UserDetails[0] : {} 
    } );

}

    } catch (error) {
     console.log(error);
      toast.error("order Not found");
   
    }finally{
      setIsLoading(false);  
    }
  };

  // useEffect(() => {
  //   console.log('Updated formData', formData.employeeId);

  //   if(formData.diffDays){
  //          setFormData((prevData) => ({
  //       ...prevData,
  //       days: formData.diffDays,
  //     }));
  //    }
  // }, [formData]);
  
  useEffect(() => {
     fetchUserData();
    getUserOrders();
getUserAllPro();
fetchSaleEmployeeData();
  }, []);

  useEffect(() => {
     if(addHistory){
      console.log('addHistory',addHistory)
     }
  }, [addHistory]);

 
  useEffect(() => {
  if (addHistory.length > 0) {
    // --- STEP 1: Deduplicate by assignId + date ---
    const seenMap = new Map();
    const dedupedHistory = [...addHistory];

    for (let i = 0; i < dedupedHistory.length; i++) {
      const entry = dedupedHistory[i];
      const { assignId, date, working } = entry;

      if (assignId && date && working !== "") {
        const key = `${assignId}_${date}`;

        if (seenMap.has(key)) {
          const prevIndex = seenMap.get(key);
          dedupedHistory[prevIndex] = entry; // keep latest
          dedupedHistory[i] = null;          // remove older
        } else {
          seenMap.set(key, i);
        }
      }
    }

    const filteredHistory = dedupedHistory.filter(e => e !== null);

    // --- STEP 2: Remove entries AFTER "left job" ---
    const finalList = filterAfterLeftJob(filteredHistory);

    // --- STEP 3: Update state if changed ---
    const isDifferent = JSON.stringify(addHistory) !== JSON.stringify(finalList);
    if (isDifferent) {
      setAddHistory(finalList);
    }
  }
}, [addHistory]);


// External helper
function filterAfterLeftJob(data) {
  const leftJobEntry = data.find(
    (entry) => entry.working === "2" && entry.assignId && entry.userId
  );

  if (!leftJobEntry) return data;

  const { assignId, userId, date: leftDate } = leftJobEntry;

  const parseDate = (str) => new Date(Date.parse(str));

  return data.filter((entry) => {
    if (
      entry.assignId === assignId &&
      entry.userId === userId &&
      entry.working !== "" &&
      entry.working !== "2"
    ) {
      const entryDate = parseDate(entry.date);
      const leftJobDate = parseDate(leftDate);
      return entryDate <= leftJobDate;
    }

    return true;
  });
}


    useEffect(() => {
      setAllEmployee([]);

      // setFormData((prevData) => ({
      //   ...prevData,
      //   employeeId: null,
      // }));

      if(formData.order ){
        if( formData.order !== '2' && formData.order !== 2){
          fetchEmployeeData(formData.order);
        }else{ 
           fetchEmployeeData(1);
        }
      }
     }, [formData.order]);
  
  
  useEffect(() => {
  console.log('UserDetails',UserDetails.length)
  }, []);

  
  useEffect(() => {
    const newSubtotal = AddProduct.reduce((acc, item) => acc + (item.total || 0), 0);
    setSubtotal(newSubtotal);

    let totalTax = 0;

    AddProduct.forEach(item => {
      const baseAmount = item.quantity * item.amount;
      const taxRate = item.tax || 0;

      if (applyIGST) {
        totalTax += baseAmount * (taxRate / 100);
      } else {
        if (applyCGST) totalTax += baseAmount * (taxRate / 100) / 2;
        if (applySGST) totalTax += baseAmount * (taxRate / 100) / 2;
      }
    });

    setTaxTotal(totalTax);

    const calculatedFinalTotal = newSubtotal - discount + shipping ;
    setFinalTotal(calculatedFinalTotal >= 0 ? calculatedFinalTotal : 0);
  }, [AddProduct, discount, shipping, applyIGST, applyCGST, applySGST]);

  useEffect(() => {

  if (formData.PickupDate && formData.ReturnDate) {
    const pickupDate = new Date(formData.PickupDate);
    const returnDate = new Date(formData.ReturnDate);
    const diffTime = returnDate - pickupDate;
    const diffDays = diffTime / (1000 * 3600 * 24); 
    setFormData((prevData) => ({
      ...prevData,
      diffDays:diffDays+1,
    })); 
    }
}, [formData.PickupDate,formData.ReturnDate,AddReceived]);

useEffect(() => {


 

},[formData.AdvanceAmt, discount, formData.SecurityAmt, formData.OnBoardDate, formData.order, formData.ReturnDate,
  formData.PickupDate, shipping, taxTotal ])
  
  const [SubmitLoading, setSubmitLoading] = useState(true); // Add loading state

      // product Features
      const [Features, setFeatures] = useState([]);
    
      const addFeatures = () => {
        const newFeatures = (
          <div key={Features.length} className="col-md-12 mb-2 d-flex gap-2">
            <input
              type="text"
              className="form-control"
              placeholder="Type Prescription"
              id={`Features${Features.length}`}
            />
    
            <button
              className="btn btn-danger d-block m-auto"
              onClick={removeFeatures}
            >
              Delete
            </button>
            <br />
          </div>
        );
    
        const updatedFeatures = [...Features, newFeatures];
        setFeatures(updatedFeatures);
      };
    
      const removeFeatures = (event) => {
        const button = event.target;
        const parentDiv = button.parentNode; // Accessing the parent div
        parentDiv.remove(); // Remove the parent div
      };
    
       const [imageDivs, setImageDivs] = useState([]);
      
        const addImageDiv = () => {
          const newImageDiv = (
            <div key={imageDivs.length} className={`col-md-3 col-6`}>
              <div className={`input-group imageupload-bx mb-3`}>
                <img
                  className="image-preview"
                  src="/assets/images/placeholder.png"
                  alt="Preview"
                  id={`imageinput${imageDivs.length}`}
                  data-bs-toggle="modal"
                  data-bs-target="#modal-default"
                />
                <input
                  type="hidden"
                  className="form-control imageopen"
                  id={`imageproduct${imageDivs.length}`}
                  name="productImg[]"
                  value="/assets/images/placeholder.png"
                />
              </div>
              <button
                className="btn btn-danger d-block m-auto"
                onClick={removeImageDiv}
              >
                Delete
              </button>
              <br />
            </div>
          );
      
          const updatedImageDivs = [...imageDivs, newImageDiv];
          setImageDivs(updatedImageDivs);
          setTimeout(function () {
            triggerChooseimg();
          }, 1);
        };
      
        const removeImageDiv = (event) => {
          const button = event.target;
          const parentDiv = button.parentNode; // Accessing the parent div
          parentDiv.remove(); // Remove the parent div
        };
      
 


  const submitData = async () => {
    const mydata = await getDecryptData();
    // toast.error(mydata.empType);

    if( mydata.type !== 0 ){
      if (mydata.empType !== 1 && mydata.empType !== 2 && mydata.empType !== 3  ){
        toast.error("You don't have access to update this.");
        return null;
      }
    }
    console.log('UserDetails',UserDetails)
if(!formData.employeeId){
  toast.error('Choose Employee ( Doctor / Nurse / Runner )');
  return null;
}
if(!formData.OnBoardDate){
  toast.error('Choose Client on Boarding Date');
  return null;
}

 
    // Check if UserDetails is an object and has the necessary properties filled
    if (!UserDetails || Object.keys(UserDetails).length === 0 || 
        !UserDetails.name || 
        !UserDetails.phone || 
        !UserDetails.email || 
        !UserDetails.gender || !UserDetails.age) {
        
        toast.error('Please Fill in all user details');
        return null;
    }

    
    setSubmitLoading(false);
  
  const now = new Date();
 
  const decryptdatajson = getDecryptData(); 
   // Use a local history array
   const localHistory = [];

   const addHistoryItem = (changeType, comment) => {
     localHistory.push({
       date: now.toLocaleDateString(),
       time: now.toLocaleTimeString(),
       userId: decryptdatajson._id,
       name: decryptdatajson.username,
       phone: decryptdatajson.phone,
       changes: changeType,
       comment,
     });
   };
 
   if (OldHistory.AdvanceAmt !== formData.AdvanceAmt)
     addHistoryItem('Edit Order Input', 'Change in Advance Money');
 
   if (OldHistory.discount !== discount)
     addHistoryItem('Edit discount Input', 'Change discount value');
 
   if (OldHistory.SecurityAmt !== formData.SecurityAmt)
     addHistoryItem('Edit Security Amt Input', 'Change Security Amt value');
 
   if (OldHistory.OnBoardDate !== formData.OnBoardDate)
     addHistoryItem('Edit On Board Date Input', 'Change On Board Date value');
 
   if (OldHistory.order !== formData.order)
     addHistoryItem('Edit order Input', 'Change to order type value');
 
   if (OldHistory.ReturnDate !== formData.ReturnDate)
     addHistoryItem('Edit Renewal Date Input', 'Change Renewal Date value');
 
   if (OldHistory.PickupDate !== formData.PickupDate)
     addHistoryItem('Edit Delivery Date Input', 'Change Delivery Date value');
 
   if (OldHistory.shipping !== shipping)
     addHistoryItem('Edit shipping Input', 'Change shipping value');
 
   if (OldHistory.taxTotal !== taxTotal)
     addHistoryItem('Edit Tax Input', 'Change Tax value');
 
         const myFeatures = document.querySelectorAll(
      '#myFeatures input'
    );
    const FeaturesValues = Array.from(myFeatures).map((input) => input.value);


  const imageInputs = document.querySelectorAll(
    '#imageContainer input[type="hidden"]'
  );
  const inputValues = Array.from(imageInputs).map((input) => input.value);

  console.log('inputValues',inputValues);

    const updatedFormData = {
      ...formData,
      status: 1,
      employeeId: formData.employeeId,
      addProduct: AddProduct,
      addRental: AddRental,
      addReceived: AddReceived,
      addReturn: AddReturn,
      discount: discount,
      shipping: shipping,
      applyIGST: applyIGST,
      applyCGST: applyCGST,
      applySGST: applySGST,
      userId : UserId,
      UserDetails:UserDetails,
      subtotal,
      finalTotal,
      taxTotal,
      type : formData.order,
      addHistory: [...addHistory, ...localHistory], // Combine old and new history
      prescription:FeaturesValues,
      images: inputValues,
    };

  
    try {

      await axiosInstance.put(`/admin/update-full-order/${id}`, updatedFormData);
      console.log('Order Updated successfully!');
      toast.success('Order Updated successfully!');
 
    } catch (error) {
      console.error('Error On Creating Order:', error);
      console.log(formData);
      toast.error(error.response.data.message);
    } finally {
      setSubmitLoading(true);
      getUserOrders();
    }
  };

  const userOptions = AllUser.map(user => ({
    value: user._id,
    label: user.username
  }));
  const employeeSaleOptions = AllSaleEmployee.map(emp => ({
    value: emp._id,
    label: emp.username
  }));

  // Format employee list for react-select
const employeeOptions = AllEmployee.map(emp => ({
  value: emp._id,
  label: emp.username
}));

const SubmitHistory_old = async (changes,comment,id,working,days,date) => {
  const now = new Date();
 
const decryptdatajson = getDecryptData();
      
if(days){
const updatedHistory = { 
  date: date || now.toLocaleDateString(), // e.g., 5/1/2025
  time: now.toLocaleTimeString(), // e.g., 10:10:30 AM
  userId: decryptdatajson._id,
  name: decryptdatajson.username,
  phone: decryptdatajson.phone,
  changes,
  comment,
  assignId : id || null,
  working: working || '',
 };

setAddHistory([...addHistory, updatedHistory]);
console.log('updatedHistoryupdatedHistory',updatedHistory)


}else{
  const updatedHistory = { 
  date: date || now.toLocaleDateString(), // e.g., 5/1/2025
  time: now.toLocaleTimeString(), // e.g., 10:10:30 AM
  userId: decryptdatajson._id,
  name: decryptdatajson.username,
  phone: decryptdatajson.phone,
  changes,
  comment,
  assignId : id || null,
  working: working || '',
 };

setAddHistory([...addHistory, updatedHistory]);
console.log('updatedHistoryupdatedHistory',updatedHistory)


}

}

const SubmitHistory = async (changes, comment, id, working, days, date) => {
  const now = new Date();
  const decryptdatajson = getDecryptData();

  const baseDate = date ? new Date(date) : new Date(); // Use provided date or now
  const dayCount = parseInt(days); // Convert days to number (if possible)

  if (!isNaN(dayCount) && dayCount > 0) {
    // Loop for 'days' number of times
    const newHistories = [];

    for (let i = 0; i < dayCount; i++) {
      const loopDate = new Date(baseDate);
      loopDate.setDate(baseDate.getDate() + i); // Add days

      const updatedHistory = {
        date: loopDate.toLocaleDateString(), // e.g., 5/1/2025
        time: now.toLocaleTimeString(),      // keep time the same
        userId: decryptdatajson._id,
        name: decryptdatajson.username,
        phone: decryptdatajson.phone,
        changes,
        comment,
        assignId: id || null,
        working: working || '',
      };

      newHistories.push(updatedHistory);
    }

    setAddHistory(prev => [...prev, ...newHistories]);
    console.log('Added multiple updatedHistory entries:', newHistories);
  } else {
    // Single entry fallback
    const updatedHistory = {
      date: baseDate.toLocaleDateString(),
      time: now.toLocaleTimeString(),
      userId: decryptdatajson._id,
      name: decryptdatajson.username,
      phone: decryptdatajson.phone,
      changes,
      comment,
      assignId: id || null,
      working: working || '',
    };

    setAddHistory(prev => [...prev, updatedHistory]);
    console.log('Added single updatedHistory:', updatedHistory);
  }
};



function addDaysToDate(dateStr, days) {
  console.log("Input dateStr:", dateStr);
  console.log("Days to add:", days);

  if (!dateStr || isNaN(days)) {
    console.warn("Invalid input to addDaysToDate");
    return "";
  }

  const cleanDateStr = dateStr.split(" ")[0];
  const [year, month, day] = cleanDateStr.split("-").map(Number);
  const date = new Date(year, month - 1, day);
  date.setDate(date.getDate() + Number(days)); // Ensure days is treated as a number

  const result = date.toISOString().split("T")[0];
  console.log("Output date:", result);
  return result;
}

  return (
    <>
    


{commentStatus && 
    <div
              className="modal fade show"
              id="modal-userr"
              tabIndex={999}
              aria-labelledby="modal-userr"
              style={{ display: "block" ,backgroundColor:'#0000004a'}}
              aria-hidden="true"
            >
              <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                  <div className="modal-body">

   <div className="col-md-12">
                  <label className="mb-2"> Select Working Status</label>

                  <ul className="customradio input-group d-flex gap-2  mb-4 px-0 mx-0">
                    <li>
                      <input
                        type="radio"
                        name="working"
                        onChange={handleChange}
                        value="1"
                        checked={formData.working === "1"}
                      />
                      <label>Working</label>
                    </li>
                    <li>
                      <input
                        type="radio"
                        name="working"
                        onChange={handleChange}
                        value="0"
                        checked={formData.working === "0"}
                      />
                      <label>On Leave  </label>
                    </li>
                     <li>
                      <input
                        type="radio"
                        name="working"
                        onChange={handleChange}
                        value="2"
                        checked={formData.working === "2"}
                      />
                      <label>Left  </label>
                    </li>

                  </ul>
                </div>
                
     
     <div className='col-md-12'>
 <div className="mb-4">
   <label htmlFor="workingdate"> Choose Date  <span className='text-danger'> ( Required )</span> </label>

   <input
    type='date'
     className="form-control"
     id="workingdate" value={formData.workingdate}
     name="workingdate" 
     onChange={handleChange}
      />
 </div>
{(formData.working === "0" ||  formData.working === "1" )  && 
<>

  <div className="mb-4">
   <label htmlFor="workingdays"> No Of {formData.working === "1" ? 'Working' : 'Leaves'}   <span className='text-danger'> ( Required )</span> </label>

   <input
    type='number'
     className="form-control"
     id="workingdays" value={formData.workingdays}
     name="workingdays" 
     onChange={handleChange}
      />
 </div>
</>

}


 <div className="mb-4">
   <label htmlFor="formcomment"> Comment  <span className='text-danger'> ( Required )</span> </label>

   <textarea
  
     className="form-control"
     id="formcomment" value={formData.formcomment}
     name="formcomment" 
     onChange={handleChange}
      />
 </div>
</div>  
 
 
                  </div>
                  <div className="modal-footer">
                    
                    <button
                      type="button"
                      className="btn btn-gray-300 me-auto"
                      
                      
                      onClick={()=>{setCommentStatus(false)}}
                    >
                      Close
                    </button>

                    <button type="button" class="btn btn-primary ms-auto" onClick={handleChangeComment} > Update Employee </button>

                  </div>
                </div>
              </div>
            </div>

}

 
 

        <div
              className="modal fade"
              id="modal-user"
              tabIndex={-1}
              aria-labelledby="modal-user"
              style={{ display: "none" }}
              aria-hidden="true"
            >
              <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                  <div className="modal-body">


                  <div className="row mb-0">
                      
                  <div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="SecurityAmt"> Client Name <span className='text-danger'>*</span>  </label>

   <input
     type="text"
     className="form-control"
     id="name" value={UserDetails?.name}
     name="name" 
     onChange={handleUserDataChange}
      />
 </div>
</div>                   

<div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="SecurityAmt"> Email <span className='text-danger'>*</span>  </label>

   <input
     type="text"
     className="form-control"
     id="email" value={UserDetails?.email}
     name="email" 
     onChange={handleUserDataChange}
      />
 </div>
</div> 

<div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="phone"> Phone <span className='text-danger'>*</span>  </label>

   <input
     type="number"
     className="form-control"
     id="phone" value={UserDetails?.phone}
     name="phone" 
     onChange={handleUserDataChange}
      />
 </div>
</div>   

 

<div className="mb-4 col-6 ">
                    <label className="form-label text-dark" htmlFor="email">
                      Gender  <span className="text-danger"> *</span>
                    </label>
                    <div className="input-group    input-sm">
                      <select
                        className="form-control"
                        value={UserDetails?.gender}
                        name="gender"
                        onChange={handleUserDataChange}
                      >
                            <option selected value="">
                          {" "}
                          Select Gender
                        </option>
                        <option value="1">Male</option>
                        <option value="2">Female</option>
                        <option value="0">Other</option>
                      </select>
                    </div>
                  </div>
                  <div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="Age"> Age   <span className="text-danger"> *</span> </label>

   <input
     type="number"
     className="form-control"
     id="age" value={UserDetails?.age}
     name="age" 
     onChange={handleUserDataChange}
      />
 </div>
</div>  



                  <div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="Address"> Address  </label>

   <input
     type="text"
     className="form-control"
     id="address" value={UserDetails?.address}
     name="address" 
     onChange={handleUserDataChange}
      />
 </div>
</div>  


 <div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="phone"> Weight  </label>

   <input
     type="text"
     className="form-control"
     id="weight" value={UserDetails?.weight}
     name="weight" 
     onChange={handleUserDataChange}
      />
 </div>
</div>  


<div className='col-md-12'>
 
 <div className="mb-4">
   <label htmlFor="disease"> Disease    </label>
    
   <textarea
     type="text"
     className="form-control"
     id="disease" 
     name="disease" 
     onChange={handleUserDataChange}
     value={UserDetails?.disease}
     />
 </div>
</div>  

                    </div>
                  </div>
                  <div className="modal-footer">
                    
                    <button
                      type="button"
                      className="btn btn-gray-300 ms-auto"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>


            <div
              className="modal fade"
              id="modal-rental"
              tabIndex={-1}
              aria-labelledby="modal-rental"
              style={{ display: "none" }}
              aria-hidden="true"
            >
              <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                  <div className="modal-body">


                  <div className="row mb-0">

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Payment method   <span className='text-danger'>*</span>  </label>

<select
className="form-control select"
id="raMethod" value={formData.raMethod}
name="raMethod" 
onChange={handleChange}
>
<option value=""> Select</option>
<option value="Cash"> Cash</option>
<option value="Cheque"> Cheque </option> 
<option value="Online"> Online </option> 
</select>


</div>
</div>        
              
   { formData.raMethod !== 'Cheque' && <>
     <div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raDate"> Date <span className='text-danger'>*</span>  </label>

<input
type="date"
className="form-control"
id="raDate" value={formData.raDate}
name="raDate" 
onChange={handleChange}
// min={new Date().toISOString().split('T')[0]} // disables past dates

/>
</div>
</div> 

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Time <span className='text-danger'>*</span>  </label>

<input
type="time"
className="form-control"
id="raTime" value={formData.raTime}
name="raTime" 
onChange={handleChange}
/>
</div>
</div> 

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Amount INR <span className='text-danger'>*</span>  </label>

<input
type="text"
className="form-control"
id="raAmount" value={formData.raAmount}
name="raAmount" 
onChange={handleChange}
/>
</div>
</div> 
   </>
   }


{ formData.raMethod === 'Cheque' && <>
<div className='bg-light row px-0 pt-3 m-0 border rounded mb-2'>
<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Cheque No </label>

<input
type="text"
className="form-control"
id="raCheckNo" value={formData.raCheckNo}
name="raCheckNo" 
onChange={handleChange}
/>
</div>
</div> 

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raBankName"> Bank Name </label>

<input
type="text"
className="form-control"
id="raBankName" value={formData.raBankName}
name="raBankName" 
onChange={handleChange}
/>
</div>
</div> 


<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raChequeAmount"> Cheque Amount </label>

<input
type="number"
className="form-control"
id="raChequeAmount" value={formData.raChequeAmount}
name="raChequeAmount" 
onChange={handleChange}
/>
</div>
</div> 

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raChequeDate"> Cheque Date </label>

<input
type="date"
className="form-control"
id="raChequeDate" value={formData.raChequeDate}
name="raChequeDate" 
onChange={handleChange}
// min={new Date().toISOString().split('T')[0]} // disables past dates

/>
</div>
</div> 

<div className='col-md-12'>

<div className="mb-4">
<label htmlFor="raAuthSignatoryName"> Auth Signatory Name {' '} <sup> (Account Holder Name) </sup> </label>

<input
type="text"
className="form-control"
id="raAuthSignatoryName" value={formData.raAuthSignatoryName}
name="raAuthSignatoryName" 
onChange={handleChange}
/> 
</div>
</div> 

</div>
</>

}
{ formData.raMethod === 'Online' &&
<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Transaction Id </label>

<input
type="text"
className="form-control"
id="raTransaction" value={formData.raTransaction}
name="raTransaction" 
onChange={handleChange}
/>
</div>
</div> 
}
<div className='col-md-12'>

<div className="mb-4">
<label htmlFor="raTime"> Comment <span className='text-danger'>*</span>  </label>

<textarea
type="text"
className="form-control"
id="raComment" value={formData.raComment}
name="raComment" 
onChange={handleChange}
/>
</div>
</div>  

     </div>




                  </div>
                  <div className="modal-footer">
                    
                  <button
                      type="button"
                      className="btn btn-gray-300 me-auto"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </button>

                    <button
                      type="button"
                      className="btn btn-primary ms-auto"
                      data-bs-dismiss="modal"
                      onClick={handleAddRental}
                    >
                      Add
                    </button>
                  </div>
                </div>
              </div>
            </div>


            <div
              className="modal fade"
              id="modal-Received"
              tabIndex={-1}
              aria-labelledby="modal-Received"
              style={{ display: "none" }}
              aria-hidden="true"
            >
              <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                  <div className="modal-body">


                  <div className="row mb-0">

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Payment method   <span className='text-danger'>*</span>  </label>

<select
className="form-control select"
id="raMethod" value={formData.raMethod}
name="raMethod" 
onChange={handleChange}
>
<option value=""> Select</option>
<option value="Cash"> Cash</option>
<option value="Cheque"> Cheque </option> 
<option value="Online"> Online </option> 
</select>


</div>
</div>        
              
   { formData.raMethod !== 'Cheque' && <>
     <div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raDate"> Date <span className='text-danger'>*</span>  </label>

<input
type="date"
className="form-control"
id="raDate" value={formData.raDate}
name="raDate" 
onChange={handleChange}
// min={new Date().toISOString().split('T')[0]} // disables past dates

/>
</div>
</div> 

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Time <span className='text-danger'>*</span>  </label>

<input
type="time"
className="form-control"
id="raTime" value={formData.raTime}
name="raTime" 
onChange={handleChange}
/>
</div>
</div> 

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Amount INR <span className='text-danger'>*</span>  </label>

<input
type="text"
className="form-control"
id="raAmount" value={formData.raAmount}
name="raAmount" 
onChange={handleChange}
/>
</div>
</div> 
   </>
   }

 

{ formData.raMethod === 'Cheque' && <>
<div className='bg-light row px-0 pt-3 m-0 border rounded mb-2'>
<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Cheque No </label>

<input
type="text"
className="form-control"
id="raCheckNo" value={formData.raCheckNo}
name="raCheckNo" 
onChange={handleChange}
/>
</div>
</div> 

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raBankName"> Bank Name </label>

<input
type="text"
className="form-control"
id="raBankName" value={formData.raBankName}
name="raBankName" 
onChange={handleChange}
/>
</div>
</div> 


<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raChequeAmount"> Cheque Amount </label>

<input
type="number"
className="form-control"
id="raChequeAmount" value={formData.raChequeAmount}
name="raChequeAmount" 
onChange={handleChange}
/>
</div>
</div> 

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raChequeDate"> Cheque Date </label>

<input
type="date"
className="form-control"
id="raChequeDate" value={formData.raChequeDate}
name="raChequeDate" 
onChange={handleChange}
// min={new Date().toISOString().split('T')[0]} // disables past dates

/>
</div>
</div> 

<div className='col-md-12'>

<div className="mb-4">
<label htmlFor="raAuthSignatoryName"> Auth Signatory Name {' '} <sup> (Account Holder Name) </sup> </label>

<input
type="text"
className="form-control"
id="raAuthSignatoryName" value={formData.raAuthSignatoryName}
name="raAuthSignatoryName" 
onChange={handleChange}
/> 
</div>
</div> 

</div>
</>

}
{ formData.raMethod === 'Online' &&
<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Transaction Id </label>

<input
type="text"
className="form-control"
id="raTransaction" value={formData.raTransaction}
name="raTransaction" 
onChange={handleChange}
/>
</div>
</div> 
}

 {formData.order === 4 && 
<div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raTime"> No. of days <span className='text-danger'>*</span>  </label>

   <input
     type="number"
     className="form-control"
     id="days" value={formData.days}
     name="days" 
     onChange={handleChange}
      />
 </div>
</div> 
}

<div className='col-md-12'>

<div className="mb-4">
<label htmlFor="raTime"> Comment <span className='text-danger'>*</span>  </label>

<textarea
type="text"
className="form-control"
id="raComment" value={formData.raComment}
name="raComment" 
onChange={handleChange}
/>
</div>
</div>  

     </div>


                  </div>
                  <div className="modal-footer">
                    
                  <button
                      type="button"
                      className="btn btn-gray-300 me-auto"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </button>

                    <button
                      type="button"
                      className="btn btn-primary ms-auto"
                      data-bs-dismiss="modal"
                      onClick={handleAddReceived}
                    >
                      Add
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="modal fade"
              id="modal-Return"
              tabIndex={-1}
              aria-labelledby="modal-Return"
              style={{ display: "none" }}
              aria-hidden="true"
            >
              <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                  <div className="modal-body">

 
                 
                  <div className="row mb-0">

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Payment method   <span className='text-danger'>*</span>  </label>

<select
className="form-control select"
id="raMethod" value={formData.raMethod}
name="raMethod" 
onChange={handleChange}
>
<option value=""> Select</option>
<option value="Cash"> Cash</option>
<option value="Cheque"> Cheque </option> 
<option value="Online"> Online </option> 
</select>


</div>
</div>        
              
   { formData.raMethod !== 'Cheque' && <>
     <div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raDate"> Date <span className='text-danger'>*</span>  </label>

<input
type="date"
className="form-control"
id="raDate" value={formData.raDate}
name="raDate" 
onChange={handleChange}
// min={new Date().toISOString().split('T')[0]} // disables past dates

/>
</div>
</div> 

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Time <span className='text-danger'>*</span>  </label>

<input
type="time"
className="form-control"
id="raTime" value={formData.raTime}
name="raTime" 
onChange={handleChange}
/>
</div>
</div> 

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Amount INR <span className='text-danger'>*</span>  </label>

<input
type="text"
className="form-control"
id="raAmount" value={formData.raAmount}
name="raAmount" 
onChange={handleChange}
/>
</div>
</div> 
   </>
   }


{ formData.raMethod === 'Cheque' && <>
<div className='bg-light row px-0 pt-3 m-0 border rounded mb-2'>
<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Cheque No </label>

<input
type="text"
className="form-control"
id="raCheckNo" value={formData.raCheckNo}
name="raCheckNo" 
onChange={handleChange}
/>
</div>
</div> 

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raBankName"> Bank Name </label>

<input
type="text"
className="form-control"
id="raBankName" value={formData.raBankName}
name="raBankName" 
onChange={handleChange}
/>
</div>
</div> 


<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raChequeAmount"> Cheque Amount </label>

<input
type="number"
className="form-control"
id="raChequeAmount" value={formData.raChequeAmount}
name="raChequeAmount" 
onChange={handleChange}
/>
</div>
</div> 

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raChequeDate"> Cheque Date </label>

<input
type="date"
className="form-control"
id="raChequeDate" value={formData.raChequeDate}
name="raChequeDate" 
onChange={handleChange}
// min={new Date().toISOString().split('T')[0]} // disables past dates

/>
</div>
</div> 

<div className='col-md-12'>

<div className="mb-4">
<label htmlFor="raAuthSignatoryName"> Auth Signatory Name {' '} <sup> (Account Holder Name) </sup> </label>

<input
type="text"
className="form-control"
id="raAuthSignatoryName" value={formData.raAuthSignatoryName}
name="raAuthSignatoryName" 
onChange={handleChange}
/> 
</div>
</div> 

</div>
</>

}
{ formData.raMethod === 'Online' &&
<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Transaction Id </label>

<input
type="text"
className="form-control"
id="raTransaction" value={formData.raTransaction}
name="raTransaction" 
onChange={handleChange}
/>
</div>
</div> 
}
<div className='col-md-12'>

<div className="mb-4">
<label htmlFor="raTime"> Comment <span className='text-danger'>*</span>  </label>

<textarea
type="text"
className="form-control"
id="raComment" value={formData.raComment}
name="raComment" 
onChange={handleChange}
/>
</div>
</div>  

     </div>




                  </div>
                  <div className="modal-footer">
                    
                  <button
                      type="button"
                      className="btn btn-gray-300 me-auto"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </button>

                    <button
                      type="button"
                      className="btn btn-primary ms-auto"
                      data-bs-dismiss="modal"
                      onClick={handleAddReturn}
                    >
                      Add Return
                    </button>
                  </div>
                </div>
              </div>
            </div>



            <div
              className="modal fade"
              id="modal-edit-rental"
              tabIndex={-1}
              aria-labelledby="modal-edit-rental"
              style={{ display: "none" }}
              aria-hidden="true"
            >
              <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                  <div className="modal-body">

 
                  <div className="row mb-0">

               <div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raTime"> Payment method   <span className='text-danger'>*</span>  </label>
 
<select
  className="form-control select"
  id="raMethod" value={formData.raMethod}
     name="raMethod" 
     onChange={handleChange}
>
<option value=""> Select</option>
  <option value="Cash"> Cash</option>
   <option value="Cheque"> Cheque </option> 
   <option value="Online"> Online </option> 
</select>


 </div>
</div>        
                             
                  { formData.raMethod !== 'Cheque' && <>
                    <div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raDate"> Date <span className='text-danger'>*</span>  </label>

   <input
     type="date"
     className="form-control"
     id="raDate" value={formData.raDate}
     name="raDate" 
     onChange={handleChange}
    //  min={new Date().toISOString().split('T')[0]} // disables past dates

      />
 </div>
</div> 
 
<div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raTime"> Time <span className='text-danger'>*</span>  </label>

   <input
     type="time"
     className="form-control"
     id="raTime" value={formData.raTime}
     name="raTime" 
     onChange={handleChange}
      />
 </div>
</div> 

<div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raTime"> Amount INR <span className='text-danger'>*</span>  </label>

   <input
     type="text"
     className="form-control"
     id="raAmount" value={formData.raAmount}
     name="raAmount" 
     onChange={handleChange}
      />
 </div>
</div> 
                  </>
                  }


{ formData.raMethod === 'Cheque' && <>
<div className='bg-light row px-0 pt-3 m-0 border rounded mb-2'>
  <div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raTime"> Cheque No </label>

   <input
     type="text"
     className="form-control"
     id="raCheckNo" value={formData.raCheckNo}
     name="raCheckNo" 
     onChange={handleChange}
      />
 </div>
</div> 

<div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raBankName"> Bank Name </label>

   <input
     type="text"
     className="form-control"
     id="raBankName" value={formData.raBankName}
     name="raBankName" 
     onChange={handleChange}
      />
 </div>
</div> 


<div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raChequeAmount"> Cheque Amount </label>

   <input
     type="number"
     className="form-control"
     id="raChequeAmount" value={formData.raChequeAmount}
     name="raChequeAmount" 
     onChange={handleChange}
      />
 </div>
</div> 


<div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raChequeDate"> Cheque Date </label>

   <input
     type="date"
     className="form-control"
     id="raChequeDate" value={formData.raChequeDate}
     name="raChequeDate" 
     onChange={handleChange}
    //  min={new Date().toISOString().split('T')[0]} // disables past dates

      />
 </div>
</div> 

<div className='col-md-12'>
 
 <div className="mb-4">
   <label htmlFor="raAuthSignatoryName"> Auth Signatory Name {' '} <sup> (Account Holder Name) </sup> </label>

   <input
     type="text"
     className="form-control"
     id="raAuthSignatoryName" value={formData.raAuthSignatoryName}
     name="raAuthSignatoryName" 
     onChange={handleChange}
      /> 
 </div>
</div> 

</div>
</>

}

 
 {formData.order === 4 && 
<div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raTime"> No. of days <span className='text-danger'>*</span>  </label>

   <input
     type="number"
     className="form-control"
     id="days" value={formData.days}
     name="days" 
     onChange={handleChange}
      />
 </div>
</div> 
}
   
{ formData.raMethod === 'Online' &&
<div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raTime"> Transaction Id </label>

   <input
     type="text"
     className="form-control"
     id="raTransaction" value={formData.raTransaction}
     name="raTransaction" 
     onChange={handleChange}
      />
 </div>
</div> 
}
<div className='col-md-12'>
 
 <div className="mb-4">
   <label htmlFor="raTime"> Comment <span className='text-danger'>*</span>  </label>

   <textarea
     type="text"
     className="form-control"
     id="raComment" value={formData.raComment}
     name="raComment" 
     onChange={handleChange}
      />
 </div>
</div>  

                    </div>





                  </div>
                  <div className="modal-footer">
                    
                  <button
                      type="button"
                      className="btn btn-gray-300 me-auto"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </button>

                    <button
                      type="button"
                      className="btn btn-primary ms-auto"
                      data-bs-dismiss="modal"
                      onClick={()=>handleUpdateRental(formData.raindex)}
                    >
                      Update
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="modal fade"
              id="modal-edit-Received"
              tabIndex={-1}
              aria-labelledby="modal-edit-Received"
              style={{ display: "none" }}
              aria-hidden="true"
            >
              <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                  <div className="modal-body">


                  <div className="row mb-0">

               <div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raTime"> Payment method   <span className='text-danger'>*</span>  </label>
 
<select
  className="form-control select"
  id="raMethod" value={formData.raMethod}
     name="raMethod" 
     onChange={handleChange}
>
<option value=""> Select</option>
  <option value="Cash"> Cash</option>
   <option value="Cheque"> Cheque </option> 
   <option value="Online"> Online </option> 
</select>


 </div>
</div>        
                             
                  { formData.raMethod !== 'Cheque' && <>
                    <div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raDate"> Date <span className='text-danger'>*</span>  </label>

   <input
     type="date"
     className="form-control"
     id="raDate" value={formData.raDate}
     name="raDate" 
     onChange={handleChange}
    //  min={new Date().toISOString().split('T')[0]} // disables past dates

      />
 </div>
</div> 
 
<div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raTime"> Time <span className='text-danger'>*</span>  </label>

   <input
     type="time"
     className="form-control"
     id="raTime" value={formData.raTime}
     name="raTime" 
     onChange={handleChange}
      />
 </div>
</div> 

<div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raTime"> Amount INR <span className='text-danger'>*</span>  </label>

   <input
     type="text"
     className="form-control"
     id="raAmount" value={formData.raAmount}
     name="raAmount" 
     onChange={handleChange}
      />
 </div>
</div> 
                  </>
                  }


{ formData.raMethod === 'Cheque' && <>
<div className='bg-light row px-0 pt-3 m-0 border rounded mb-2'>
  <div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raTime"> Cheque No </label>

   <input
     type="text"
     className="form-control"
     id="raCheckNo" value={formData.raCheckNo}
     name="raCheckNo" 
     onChange={handleChange}
      />
 </div>
</div> 

<div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raBankName"> Bank Name </label>

   <input
     type="text"
     className="form-control"
     id="raBankName" value={formData.raBankName}
     name="raBankName" 
     onChange={handleChange}
      />
 </div>
</div> 


<div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raChequeAmount"> Cheque Amount </label>

   <input
     type="number"
     className="form-control"
     id="raChequeAmount" value={formData.raChequeAmount}
     name="raChequeAmount" 
     onChange={handleChange}
      />
 </div>
</div> 

<div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raChequeDate"> Cheque Date </label>

   <input
     type="date"
     className="form-control"
     id="raChequeDate" value={formData.raChequeDate}
     name="raChequeDate" 
     onChange={handleChange}
    //  min={new Date().toISOString().split('T')[0]} // disables past dates

      />
 </div>
</div> 

<div className='col-md-12'>
 
 <div className="mb-4">
   <label htmlFor="raAuthSignatoryName"> Auth Signatory Name {' '} <sup> (Account Holder Name) </sup> </label>

   <input
     type="text"
     className="form-control"
     id="raAuthSignatoryName" value={formData.raAuthSignatoryName}
     name="raAuthSignatoryName" 
     onChange={handleChange}
      /> 
 </div>
</div> 

</div>
</>

}
{ formData.raMethod === 'Online' &&
<div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raTime"> Transaction Id </label>

   <input
     type="text"
     className="form-control"
     id="raTransaction" value={formData.raTransaction}
     name="raTransaction" 
     onChange={handleChange}
      />
 </div>
</div> 
}


 {formData.order === 4 && 
<div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="raTime"> No. of days <span className='text-danger'>*</span>  </label>

   <input
     type="number"
     className="form-control"
     id="days" value={formData.days}
     name="days" 
     onChange={handleChange}
      />
 </div>
</div> 
}

<div className='col-md-12'>
 
 <div className="mb-4">
   <label htmlFor="raTime"> Comment <span className='text-danger'>*</span>  </label>

   <textarea
     type="text"
     className="form-control"
     id="raComment" value={formData.raComment}
     name="raComment" 
     onChange={handleChange}
      />
 </div>
</div>  

                    </div>



                  </div>
                  <div className="modal-footer">
                    
                  <button
                      type="button"
                      className="btn btn-gray-300 me-auto"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </button>

                    <button
                      type="button"
                      className="btn btn-primary ms-auto"
                      data-bs-dismiss="modal"
                      onClick={()=>handleUpdateReceived(formData.raindex)}
                    >
                      Update Security
                    </button>
                  </div>
                </div>
              </div>
            </div>


            <div
              className="modal fade"
              id="modal-edit-Return"
              tabIndex={-1}
              aria-labelledby="modal-edit-Return"
              style={{ display: "none" }}
              aria-hidden="true"
            >
              <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                  <div className="modal-body">


                  <div className="row mb-0">

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Payment method   <span className='text-danger'>*</span>  </label>

<select
className="form-control select"
id="raMethod" value={formData.raMethod}
name="raMethod" 
onChange={handleChange}
>
<option value=""> Select</option>
<option value="Cash"> Cash</option>
<option value="Cheque"> Cheque </option> 
<option value="Online"> Online </option> 
</select>


</div>
</div>        
              
   { formData.raMethod !== 'Cheque' && <>
     <div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raDate"> Date <span className='text-danger'>*</span>  </label>

<input
type="date"
className="form-control"
id="raDate" value={formData.raDate}
name="raDate" 
onChange={handleChange}
// min={new Date().toISOString().split('T')[0]} // disables past dates

/>
</div>
</div> 

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Time <span className='text-danger'>*</span>  </label>

<input
type="time"
className="form-control"
id="raTime" value={formData.raTime}
name="raTime" 
onChange={handleChange}
/>
</div>
</div> 

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Amount INR <span className='text-danger'>*</span>  </label>

<input
type="text"
className="form-control"
id="raAmount" value={formData.raAmount}
name="raAmount" 
onChange={handleChange}
/>
</div>
</div> 
   </>
   }


{ formData.raMethod === 'Cheque' && <>
<div className='bg-light row px-0 pt-3 m-0 border rounded mb-2'>
<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Cheque No </label>

<input
type="text"
className="form-control"
id="raCheckNo" value={formData.raCheckNo}
name="raCheckNo" 
onChange={handleChange}
/>
</div>
</div> 

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raBankName"> Bank Name </label>

<input
type="text"
className="form-control"
id="raBankName" value={formData.raBankName}
name="raBankName" 
onChange={handleChange}
/>
</div>
</div> 


<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raChequeAmount"> Cheque Amount </label>

<input
type="number"
className="form-control"
id="raChequeAmount" value={formData.raChequeAmount}
name="raChequeAmount" 
onChange={handleChange}
/>
</div>
</div> 

<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raChequeDate"> Cheque Date </label>

<input
type="date"
className="form-control"
id="raChequeDate" value={formData.raChequeDate}
name="raChequeDate" 
onChange={handleChange}
// min={new Date().toISOString().split('T')[0]} // disables past dates

/>
</div>
</div> 

<div className='col-md-12'>

<div className="mb-4">
<label htmlFor="raAuthSignatoryName"> Auth Signatory Name {' '} <sup> (Account Holder Name) </sup> </label>

<input
type="text"
className="form-control"
id="raAuthSignatoryName" value={formData.raAuthSignatoryName}
name="raAuthSignatoryName" 
onChange={handleChange}
/> 
</div>
</div> 

</div>
</>

}
{ formData.raMethod === 'Online' &&
<div className='col-md-6'>

<div className="mb-4">
<label htmlFor="raTime"> Transaction Id </label>

<input
type="text"
className="form-control"
id="raTransaction" value={formData.raTransaction}
name="raTransaction" 
onChange={handleChange}
/>
</div>
</div> 
}
<div className='col-md-12'>

<div className="mb-4">
<label htmlFor="raTime"> Comment <span className='text-danger'>*</span>  </label>

<textarea
type="text"
className="form-control"
id="raComment" value={formData.raComment}
name="raComment" 
onChange={handleChange}
/>
</div>
</div>  

     </div>



                  </div>
                  <div className="modal-footer">
                    
                  <button
                      type="button"
                      className="btn btn-gray-300 me-auto"
                      data-bs-dismiss="modal"
                    >
                      Close
                    </button>

                    <button
                      type="button"
                      className="btn btn-primary ms-auto"
                      data-bs-dismiss="modal"
                      onClick={()=>handleUpdateReturn(formData.raindex)}
                    >
                      Update Return
                    </button>
                  </div>
                </div>
              </div>
            </div>

{!IsLoading ? 

<div className='bg-white p-3'>
<h4> Order </h4>
<hr className='my-1 p-0'/>


<div className='row mt-4'>


<div className="mb-4 d-none">
<div className='col-md-4'>

<label htmlFor="eventTitle">
                    
                    Order Type
                  </label>{" "}

                  <select
                    className="form-control select"
                    name="order"
                    style={{ width: "100%" }} 
                     value={formData.order}
                 onChange={handleChange}
                  >
                    <option > Select type</option>
                    <option value={1} > Order</option>
                    <option value={2} > Rental </option>
                    <option value={3} > Doctors appointment </option>
                    <option value={4} > Nurse </option>

                    </select>

</div>
                   
                      </div>
                     


<div className="row mb-0 bg-light p-2 pt-3 mx-0 border rounded mb-2">
                      
<div className='col-md-6'>
     
     <div className="mb-4">
       <label htmlFor="phone"> Phones <span className='text-danger'>*</span>  </label>
    
       <input
         type="number"
         className="form-control"
         id="phone" value={UserDetails.phone}
         name="phone" 
         maxLength="10"
      onChange={(e) => {
    const value = e.target.value;
    // Allow only digits and up to 10 characters
    if (/^\d{0,10}$/.test(value)) {
      handleUserDataChange(e);
    }
  }}
         onWheel={(e) => e.target.blur()} // Use a function to handle the wheel event
         onKeyDown={(e) => {
           if (
             e.key === "ArrowUp" ||
             e.key === "ArrowDown"
           ) {
             e.preventDefault(); // Prevent the default action for up/down keys
           }
         }}
         
          />
     </div>
    </div>   
    

                      <div className='col-md-6'>
                 

     <div className="mb-4">
       <label htmlFor="SecurityAmt"> Client Name <span className='text-danger'>*</span>  </label>
    
       <input
         type="text"
         className="form-control"
         id="name" value={UserDetails.name}
         name="name" 
         onChange={handleUserDataChange}
          />
     </div>
    </div>                   
    
    <div className='col-md-3'>
     
     <div className="mb-4">
       <label htmlFor="SecurityAmt"> Email <span className='text-danger'>*</span>  </label>
    
       <input
         type="text"
         className="form-control"
         id="email" value={UserDetails.email}
         name="email" 
         onChange={handleUserDataChange}
          />
     </div>
    </div> 
    
    <div className='col-md-3'>
 
 <div className="mb-4">
   <label htmlFor="SecurityAmt"> Age <span className='text-danger'>*</span>  </label>

   <input
     type="text"
     className="form-control"
     id="age" value={UserDetails.age}
     name="age" 
     onChange={handleUserDataChange}
      />
 </div>
</div>  
     
        
     <div className='col-md-3'>
     
     <div className="mb-4">
       <label htmlFor="phone"> Weight  </label>
    
       <input
         type="text"
         className="form-control"
         id="weight" value={UserDetails.weight}
         name="weight" 
         onChange={handleUserDataChange}
          />
     </div>
    </div>  
    
    
    <div className="mb-4 col-md-3 ">
                        <label className="form-label text-dark" htmlFor="email">
                          Gender  <span className="text-danger"> *</span>
                        </label>
                        <div className="input-group    input-sm">
                          <select
                            className="form-control"
                            value={UserDetails.gender}
                            name="gender"
                            onChange={handleUserDataChange}
                          >
                            <option selected disabled>
                              {" "}
                              Select Gender
                            </option>
                            <option value="1">Male</option>
                            <option value="2">Female</option>
                            <option value="0">Other</option>
                          </select>
                        </div>
                      </div>
    
      <div className="mb-4 col-md-3 ">
                        <label className="form-label text-dark" htmlFor="email">
                          Do you have Company ? 
                        </label>
                        <div className="input-group    input-sm">
                          <select
                            className="form-control"
                            value={UserDetails.company}
                            name="company"
                            onChange={handleUserDataChange}
                          >
                            
                            <option value="yes">Yes</option>
                            <option value="no" selected>NO</option>
                           </select>
                        </div>
                      </div>
                     
                      {UserDetails.company === 'yes' && <>
 
                      <div className='col-md-12'/>
                      <div className='col-md-4'>
     
     <div className="mb-4">
       <label htmlFor="companyName"> Company Name  </label>
    
       <input
         type="text"
         className="form-control"
         id="companyName" value={UserDetails.companyName}
         name="companyName" 
         onChange={handleUserDataChange}
          />
     </div>
    </div>  
    
    <div className='col-md-4'>
     
     <div className="mb-4">
       <label htmlFor="companyGST"> Company GST  </label>
    
       <input
         type="text"
         className="form-control"
         id="companyGST" value={UserDetails.companyGST}
         name="companyGST" 
         onChange={handleUserDataChange}
          />
     </div>
    </div>  
    
        <div className='col-md-4'>
     
     <div className="mb-4">
       <label htmlFor="companyGST"> Company Address  </label>
    
       <input
         type="text"
         className="form-control"
         id="companyAddress" value={UserDetails.companyAddress}
         name="companyAddress" 
         onChange={handleUserDataChange}
          />
     </div>
    </div> 


                      </>}
    
                      <div className='col-md-12'>
     
     <div className="mb-4">
       <label htmlFor="Address"> Address  </label>
    
       <textarea
         type="text"
         className="form-control"
         id="address" value={UserDetails.address}
         name="address" 
         onChange={handleUserDataChange}
          />
     </div>
    </div>  
    
 
    
    <div className='col-md-12'>
     
     <div className="mb-4">
       <label htmlFor="disease"> Disease    </label>
    
       <textarea
         type="text"
         className="form-control"
         id="disease" 
         name="disease" 
         onChange={handleUserDataChange}
          >{UserDetails.disease}</textarea>
     </div>
    </div>  
    
                        </div>

                        
<div className='col-md-6 '>

           

                          <div className="mb-4">
                    <label htmlFor="eventTitle">
                    
                      Choose User
                    </label>{" "}
                    

<div className='d-flex gap-3 align-items-center'>

                    {/* <select
                      className="form-control select"
                      name="UserId"
                      style={{ width: "100%" }} 
                      onChange={(e) => {
                        const id = e.target.value;
                        setUserId(id); // optional: track selected ID
                        handleUserChange(id);
                      }}       
                         >
                      <option > Select User</option>


                      {AllUser.length > 0 ? (

                        AllUser.map(User => (
                          <option value={User._id} key={User._id} selected={User._id === UserId}
                            >   {User.username}</option>
                        ))
                      ) : (
                        <p>No User found.</p>
                      )}



                    </select>
                   */}

  <Select
    className="basic-single w-100"
    classNamePrefix="select "
    name="UserId"
    options={userOptions}
    value={userOptions.find(option => option.value === UserId)}
    onChange={(selectedOption) => {
      // setUserId(selectedOption.value); // optional tracking
      handleUserChange(selectedOption.value);
    }}
    placeholder="Select User"
    isSearchable
  />

                    {UserDetails && Object.keys(UserDetails).length > 0 && 
<button className='btn btn-primary btn-sm w-auto d-none' style={{ minWidth: 'max-content' }}
 data-bs-toggle="modal" data-bs-target="#modal-user"
>
  View Details
</button>
}
                    </div>

                  


                  </div>

                        </div>
               
                                {(decryptdatajson.type !== 1 && decryptdatajson.empType !== 3 ) && 


                        <div className='col-md-6'>

                
<div className="mb-4">
<label htmlFor="eventTitle">

Choose Employee ( Sales )
</label>{" "}

{/* <select
className="form-control select"
name="employeeSaleId"
style={{ width: "100%" }}  
value={formData.employeeSaleId}
onChange={handleChange}
>
<option > Select Employee</option>


{AllSaleEmployee.length > 0 ? (

AllSaleEmployee.map(User => (
<option value={User._id} key={User._id} selected={User._id === UserId}
>   {User.username}</option>
))
) : (
<p>No User found.</p>
)}
 
</select> */}




<Select
    name="employeeSaleId"
    className="basic-single w-100"
    classNamePrefix="select"
    options={employeeSaleOptions}
    value={employeeSaleOptions.find(option => option.value === formData.employeeSaleId)}
    onChange={(selectedOption) => {
      const event = {
        target: {
          name: 'employeeSaleId',
          value: selectedOption.value,
          label: selectedOption.label
        }
      };
      handleChange(event); // Reuse your existing handleChange logic
    }}
    placeholder="Select Employee"
    isSearchable
  />
 

</div>

</div>
}

  {(decryptdatajson.type !== 1 && decryptdatajson.empType !== 3 ) && 

<div className='col-md-6'>

                
<div className="mb-4">
<label htmlFor="eventTitle">

Choose Employee {formData.order  === 1 && 'Runner'}
 {formData.order  === 2 && 'Runner'} 
{formData.order  === 3 && 'Doctor'} 
 {formData.order  === 4 && 'Nurse'}  
</label>{" "}

{/* <select
className="form-control select"
name="employeeId"
style={{ width: "100%" }}  
value={formData.employeeId}
onChange={handleChange}
>
<option > Select Employee</option>


{AllEmployee.length > 0 ? (

AllEmployee.map(User => (
<option value={User._id} key={User._id}  
>   {User.username}</option>
))
) : (
<p>No User found.</p>
)}
 
</select> */}


<Select
    name="employeeId"
    className="basic-single"
    classNamePrefix="select"
    options={employeeOptions}
    value={employeeOptions.find(option => option.value === formData.employeeId)}
    onChange={(selectedOption) => {
      // Simulate native event to work with handleChange
      const event = {
        target: {
          name: 'employeeId',
          value: selectedOption.value,
          label: selectedOption.label
        }
      };
      handleChange(event);
    }}
    placeholder="Select Employee"
    isSearchable
  />

</div>

</div>
}



                      <div className='col-md-4'>

<div className="mb-4">
 <label htmlFor="PickupDate">  {formData.order === 4 ? 'DUTY Start Date' : formData.order === 3 ? 'Appoinment Date' : 'Delivery Date' }  <span className='text-danger'>*</span>  </label>
 
 <input
   type="date"
   className="form-control"
   id="PickupDate" value={formData.PickupDate}
   name="PickupDate" onChange={handleChange}
 />
</div>
</div>


 {formData.order  === 3 &&
 <>

 <div className='col-md-3 mb-4'>

<label htmlFor="eventTime">
                    
                Appoinment  Time
                  </label> 
<input className="form-control" id="eventTime" type='time' value={formData.Ltime}  name="Ltime" onChange={handleChange} /> 

</div>

<div className='col-md-3 mb-4'>

<label htmlFor="source">
                    
                Appoinment Source
                  </label> 
<select className="form-control" id="appoinment" value={formData.appoinment}  name="appoinment" onChange={handleChange} >
   <option value={''} >Select Source
    </option>
  <option value={0}>YNB Appoinment
    </option>
      <option value={1}>My Appoinment
    </option>

    </select> 

</div>

 </>


}


{(formData.order !== 1 &&  formData.order !== 3 )&&
<>

<div className='col-md-4'>
 
 <div className="mb-4">
   <label htmlFor="days">Days <span className='text-danger'>*</span>  </label>

   <input
     type="number"
     className="form-control"
     id="diffDays" value={formData.diffDays}
     name="diffDays" onChange={handleChange}
     min={formData.diffDays}
     />
 </div>
</div>


<div className='col-md-4'>

<div className="mb-4">
 <label htmlFor="ReturnDate"> Renewal Date <span className='text-danger'>*</span>  </label>

 <input
   type="date"
   className="form-control"
   id="ReturnDate" value={formData.ReturnDate}
   name="ReturnDate" onChange={handleChange}
   min={formData.PickupDate}
   />
<br/>
   <p className='bg-warning mt-2 px-3 py-1 rounded-3 text-dark w-auto d-inline'> No. of days - {formData.diffDays} </p>
</div>
</div>

<div className={`col-md-6 ${id !== '4' && 'd-none '}`}>
 
 <div className="mb-4">
   <label htmlFor="dutyHr"> Duty Hours  <span className='text-danger'>*</span>  </label>

   <input
     type="text"
     className="form-control"
     id="dutyHr" 
     value={formData.dutyHr}
     onChange={handleChange}
     name="dutyHr"  
       />
 
  </div>
</div>



{formData.order !== 4 && 
<>

<div className='col-md-6'>

<div className="mb-4">
 <label htmlFor="SecurityAmt">Security Amt   </label>

 <input
   type="number"
   className="form-control"
   id="SecurityAmt" value={formData.SecurityAmt}
   name="SecurityAmt" onChange={handleChange}
   min={formData.SecurityAmt}
   />
</div>
</div>

<div className='col-md-6'>

<div className="mb-4">
 <label htmlFor="AdvanceAmt"> Advance Money  </label>

 <input
   type="number"
   className="form-control"
   id="AdvanceAmt" value={formData.AdvanceAmt}
   name="AdvanceAmt" onChange={handleChange}
   min={formData.SecurityAmt}
   />
</div>
</div>

</> }  

<div className='col-md-6'>
 
 <div className="mb-4">
   <label htmlFor="OnBoardDate"> Client on Boarding Date <span className='text-danger'>*</span>  </label>

   <input
     type="date"
     className="form-control"
     id="OnBoardDate" value={formData.OnBoardDate}
     name="OnBoardDate" onChange={handleChange}
     />
 </div>
</div>

<div className={`col-md-6 ${formData.order !== 4 && 'd-none '}`}>
 
 <div className="mb-4">
   <label htmlFor="name"> Duty Hours  <span className='text-danger'>*</span>  </label>

   <input
     type="text"
     className="form-control"
     id="dutyHr" 
     value={formData.dutyHr}
     onChange={handleChange}
     name="dutyHr"  
       />
 
  </div>
</div>


</>
}






<div className='col-md-12'>
            {/* Search */}
                <div
                  className={`input-group d-flex me-5 w-500 searchbox flex-fill ${!showSearch && "search-view"
                    } `}
                  style={{ backgroundColor: "#f3f7fb" }}
                >
                  <input
                    id="searchInput"
                    className="form-control searchinput"
                    type="text"
                    placeholder="Search for products,category and more"
                    value={searchQuery}
                    onChange={handleInputChange}
                  />
                  <button
                    type="button"
                    className="btn btn-primary bg-gradient d-none d-lg-block search  text-secondary"
                  >
                    <i className="ri-search-line fw-bold" />
                  </button>

           
                  {searchQuery && (
                    <>
                      <button
                        type="button"
                        className="btn btn-primary bg-gradient d-none d-lg-block close"
                        onClick={handleClearClick}
                      >
                        {" "}
                        <i class="navbar-actions-icon ri-close-line fs-7"></i>{" "}
                      </button>
                    </>
                  )}
                </div>

                {searchQuery && (
                    <>
                      <ul class="searchfloat mt-3 p-0">
                        {searchQuery &&
                          filteredProducts &&
                          filteredProducts.map((item) => {
                            console.log("item.slug", item.slug);
                            const myslug =  item._id; // Make sure `data` and `Product` are defined and available in the scope.
                            return (
                              <li key={item.id} className='d-block'>
                                <Link 
                                  onClick={()=> handleAddProduct(item)}
                                > 
                                  <i class="ri-shopping-bag-line"></i>{" "}
                                  {item.title}   | {item.brandName}  | {item.brandName} 
    {formData.order  === 1 || formData.order  === 4 ? 
 <>
  {(item.stock || item.stock === 0 )&& <> |  <span class="badge bg-warning font-small px-2 py-1 text-white-800 ms-1 fw-bold"> {item.reStock} available</span> </>} <span> </span>
</> :
<>
  {(item.stock || item.stock === 0 )&& <> |  <span class="badge bg-warning font-small px-2 py-1 text-white-800 ms-1 fw-bold"> {item.stock} available</span> </>} <span> </span>
</>
                                  }  

                                </Link>
                              </li>
                            );
                          })}
                      
                      </ul>
                    </>
                  )}


                {/* Search */}

</div>

<div className='col-md-12'>
<div className='overflow-auto'>
<table className="table table-bordered mt-3">
<thead>
  <tr>
    <th>#</th>
     <th>Name</th>
    <th>Price</th>
    <th>Quantity</th>
    <th>Serial No. / Model</th> 
    <th>Tax (%)</th>
    <th>Total Amount</th>
    <th>Action</th>
  </tr>
</thead>
<tbody>
  {AddProduct.length > 0 ? (
    AddProduct.map((product, index) => (
      <tr key={product.id || index}>
        <td>{index + 1}</td>
         <td style={{Width:'100%'}} >
         <p style={{width:150,whiteSpace:'normal'}}> 
           <textarea
            type="text"
             className="form-control p-1 shadow-none"
            value={product.title}
            onChange={(e) => handleTitleChange(index, e.target.value)}
          />
            </p>
         </td>
        <td style={{minWidth:150,maxWidth:80}} >
        <input
            type="number"
              className="form-control"
            value={product.amount}
            onChange={(e) => handleAmtChange(index, e.target.value)}
          />
         </td>
         

        <td style={{Width:80,maxWidth:80}} >
          <input
            type="number"
            min="1"
            className="form-control"
            value={product.quantity}
            onChange={(e) => handleQuantityChange(index, e.target.value)}
          />
        </td>

        <td style={{Width:80,maxWidth:80}} >
        <input
              type="number"
              min="1"
              className="form-control"
              value={product.serialNumber}
              onChange={(e) => handleSerialNumberChange(index, e.target.value)}
            />
       
         </td>
        
        <td style={{ minWidth: 100,width:100 }}>
        <input
          type="number"
          className="form-control px-1 text-center"
          value={product.tax || 0}
          onChange={(e) => handleTaxChange(index, e.target.value)}
        />
      </td>
        <td style={{Width:80,maxWidth:80}} >
        ₹ {product.total.toFixed(2)}
            
        </td>

        <td style={{Width:80,maxWidth:80}} >   <button
            className="btn btn-danger btn-sm"
            onClick={() => handleRemoveProduct(index)}
          >
            <i className="ri-delete-bin-line"></i> Delete
          </button>
          </td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="7" className="text-center">No products added</td>
    </tr>
  )}
</tbody>
</table>
</div>
{AddProduct.length > 0 && (
<div className='col-md-4 ms-auto'>

<table className="table table-bordered">
  <tbody>
    <tr>
      <th>Subtotal:</th>
      <td>₹ {subtotal.toFixed(2)}</td>
    </tr>

    
 
    <tr>
      <th>Discount:</th>
      <td>
        <input
          type="number"
          className="form-control"
          value={discount}
          onChange={handleDiscountChange}
          min="0"
        />
      </td>
    </tr>
     
    <tr>
      <th>Shipping:</th>
      <td>
        <input
          type="number"
          className="form-control"
          value={shipping}
          onChange={handleShippingChange}
          min="0"
        />
      </td>
    </tr>
    <tr>
    
    
    <th>Tax {applyIGST ? '(IGST)' : '(CGST + SGST)'}: <hr/>
    <div className="d-block gap-3 mb-3">
      <div className="form-check">
        <input
          type="checkbox"
          className="form-check-input"
          id="igstCheck"
          defaultChecked={applyIGST}
          onChange={() => {
            setApplyIGST(!applyIGST);
            if (!applyIGST) {
              setApplyCGST(false);
              setApplySGST(false);
            }
          }}
        />
        <label className="form-check-label" htmlFor="igstCheck">Apply IGST</label>
      </div>
      <div className="form-check">
        <input
          type="checkbox"
          className="form-check-input"
          id="cgstCheck"
          defaultChecked={applyCGST}
          onChange={() => {
            setApplyCGST(!applyCGST);
            if (!applyCGST) setApplyIGST(false);
          }}
        />
        <label className="form-check-label" htmlFor="cgstCheck">Apply CGST</label>
      </div>
      <div className="form-check">
        <input
          type="checkbox"
          className="form-check-input"
          id="sgstCheck"
          defaultChecked={applySGST}
          onChange={() => {
            setApplySGST(!applySGST);
            if (!applySGST) setApplyIGST(false);
          }}
        />
        <label className="form-check-label" htmlFor="sgstCheck">Apply SGST</label>
      </div>
    </div>
    </th>

    <td>  ₹ {(applyIGST || applyCGST || applySGST) ? taxTotal.toFixed(2) : 0.00} </td>
</tr>

    <tr>
      <th>Final Total:</th>
      <td><strong>₹ {finalTotal.toFixed(2)}</strong></td>
    </tr>
  </tbody>
</table>

</div>
)}

</div>

{formData.order === 3 && 
<>

  <div className="col-lg-4">
                                                  <Gallery />
  </div>


  <div className="col-md-12">
                              <div className="mb-4">
                                <label
                                  htmlFor="KeyFeatures"
                                  className="d-block mb-2"
                                >
                                  Key Prescription
                                </label>

                                <div id="myFeatures">
                                  {formData.prescription && (
                                    <>
                                      {formData.prescription.map(
                                        (features, index) => (
                                          <div
                                            className="col-md-12 mb-2 d-flex gap-2"
                                            key={index}
                                          >
                                            <input
                                              type="text"
                                              className="form-control"
                                              id={`Features${index + 1}`}
                                              placeholder="Type Prescription"
                                              name="productImg[]"
                                              value={features}
                                            />

                                            <button
                                              className="btn btn-danger d-block m-auto"
                                              onClick={removeFeatures}
                                            >
                                              Delete
                                            </button>
                                            <br />
                                          </div>
                                        )
                                      )}
                                    </>
                                  )}

                                  {Features.map((Features, index) => (
                                    <React.Fragment key={index}>
                                      {Features}
                                    </React.Fragment>
                                  ))}
                                </div>

                                <button
                                  onClick={addFeatures}
                                  className="btn btn-secondary btn-sm"
                                  type="button"
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="20"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    stroke="#1f2937"
                                    stroke-width="2"
                                    stroke-linecap="square"
                                    stroke-linejoin="arcs"
                                  >
                                    <line x1="12" y1="5" x2="12" y2="19"></line>
                                    <line x1="5" y1="12" x2="19" y2="12"></line>
                                  </svg>
                                  Add Prescription
                                </button>
                              </div>
                            </div>


    <div className="col-md-12 mb-3">
                              <button
                                onClick={addImageDiv}
                                className="btn btn-secondary btn-sm mb-3"
                                type="button"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="mx-1"
                                  width="20"
                                  height="20"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="#1f2937"
                                  stroke-width="1.5"
                                  stroke-linecap="square"
                                  stroke-linejoin="arcs"
                                >
                                  <rect
                                    x="3"
                                    y="3"
                                    width="18"
                                    height="18"
                                    rx="2"
                                  />
                                  <circle cx="8.5" cy="8.5" r="1.5" />
                                  <path d="M20.4 14.5L16 10 4 20" />
                                </svg>
                                Add Image  
                              </button>
                              <div id="imageContainer" className="row">
                                
                                    {formData.images.map((image, index) => (
                                      <div
                                        className="col-md-3 col-6"
                                        key={index}
                                      >
                                        <div
                                          className={`input-group imageupload-bx mb-3`}
                                        >
                                          <img
                                            className="image-preview"
                                            src={image}
                                            alt="Preview"
                                            id={`imageinputN${index + 1}`}
                                            data-bs-toggle="modal"
                                            data-bs-target="#modal-default"
                                          />
                                          <input
                                            type="hidden"
                                            className="form-control imageopen"
                                            id={`imageproductN${index + 1}`}
                                            name="productImg[]"
                                            value={image}
                                          />
                                        </div>
                                        <button
                                          className="btn btn-danger d-block m-auto"
                                          onClick={removeImageDiv}
                                        >
                                          Delete
                                        </button>
                                        <br />
                                      </div>
                                    ))}
                                 

                                {imageDivs.map((imageDiv, index) => (
                                  <React.Fragment key={index}>
                                    {imageDiv}
                                  </React.Fragment>
                                ))}
                              </div>
                            </div>
                      </>      
                            }

{(formData.order !== 1 && formData.order  !== 3 ) &&
<>

<div className={`col-md-12 my-4 ${formData.order === 4 && 'd-none'}`}>
<div className='d-flex justify-content-between'>
<h4>Rental Amount   </h4>
<button className="btn btn-primary btn-sm w-auto" data-bs-toggle="modal" data-bs-target="#modal-rental"  >Add Rental</button>
</div>
<hr/>

<div className='overflow-auto'>
<table className="table table-bordered mt-3">
<thead>
  <tr>
    <th>#</th>
     <th>Date</th>
     <th>Amount INR	</th>
     <th>Payment Method	</th>
    <th> Transaction Id </th>
    <th> Comment </th>
    <th> Action </th>

  </tr>
</thead>
<tbody>
  {AddRental.length > 0 ? (
    AddRental.map((rental, index) => (
      <tr key={index}>
        <td>{index + 1}</td>
         <td>{rental.method === 'Cheque' ? rental.chequeDate : rental.date}</td>
          <td>{rental.method === 'Cheque' ? rental.chequeAmount : rental.amount }</td>
          <td>{rental.method}</td>
         <td  >{rental.transaction !== '' ? rental.transaction : 'NA' }</td>
         <td style={{Width:80,maxWidth:80}} > <p  style={{
    maxWidth: '80px',
    whiteSpace: 'break-spaces',
    WebkitLineClamp: 2,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    WebkitBoxOrient: 'vertical',
    display: '-webkit-box',
    padding:'0px',
  }} >{rental.comment }
      </p> 
         </td>
        <td style={{Width:80,maxWidth:80}} > 
        <button
            className="btn btn-primary btn-sm me-2"
            onClick={() => handleEditRental(index)} data-bs-toggle="modal" data-bs-target="#modal-edit-rental"
          >
            <i className="ri-pencil-fill"></i>  
          </button>
            <button
            className="btn btn-danger btn-sm"
            onClick={() => handleRemoveRental(index)}
          >
            <i className="ri-delete-bin-line"></i>  
          </button>
          </td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="8" className="text-center">No Rental Added</td>
    </tr>
  )}
</tbody>
</table>
</div>

{AddRental.length > 0 && (
<div className='col-md-4 ms-auto'>

<table className="table table-bordered">
  <tbody>
    
    <tr>
      <th>Final Total:</th>
      <td><strong>₹ {AddRental.reduce((acc, rental) => acc + parseFloat(rental.amount || 0), 0).toFixed(2)} </strong></td>
    </tr>
  </tbody>
</table>

</div>
)}

</div>
 
<div className='col-md-12 my-4'>
<div className='d-flex justify-content-between'>
<h4>  {formData.order === 4 ? 'Payment Mangement' : 'Security Details' }
</h4>
<button className="btn btn-primary btn-sm w-auto" data-bs-toggle="modal" data-bs-target="#modal-Received"  > {formData.order === 4 ? 'Add Payment' : 'Add Security Details' }    </button>
</div>
<hr/>

<div className='overflow-auto'>
<table className="table table-bordered mt-3">
<thead>
  <tr>
  <th>#</th>
     <th>Date</th>
     <th>Amount INR	</th>
     <th>Payment Method	</th>
      {formData.order === 4 && <th>Days	</th> }

    <th> Transaction Id </th>
    <th> Comment </th>
    <th> Action </th> 
  </tr>
</thead>
<tbody>
  {AddReceived.length > 0 ? (
    AddReceived.map((rental, index) => (
      <tr key={index}>
      <td>{index + 1}</td>
       <td>{rental.method === 'Cheque' ? rental.chequeDate : rental.date}</td>
        <td>{rental.method === 'Cheque' ? rental.chequeAmount : rental.amount }</td>
        <td>{rental.method}</td>
    {formData.order  === 4 && <td>{rental.days !== '' ? rental.days : 'NA' }	</td> }
       <td  >{rental.transaction !== '' ? rental.transaction : 'NA' }</td>
       <td style={{Width:80,maxWidth:80}} > <p  style={{
  maxWidth: '80px',
  whiteSpace: 'break-spaces',
  WebkitLineClamp: 2,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  WebkitBoxOrient: 'vertical',
  display: '-webkit-box',
  padding:'0px',
}} >{rental.comment }
    </p> 
       </td>
      <td style={{Width:80,maxWidth:80}} > 
      <button
          className="btn btn-primary btn-sm me-2"
          onClick={() => handleEditReceived(index)} data-bs-toggle="modal" data-bs-target="#modal-edit-Received"
        >
          <i className="ri-pencil-fill"></i>  
        </button>
          <button
          className="btn btn-danger btn-sm"
          onClick={() => handleRemoveReceived(index)}
        >
          <i className="ri-delete-bin-line"></i>  
        </button>

         <br/>
         {formData.order === 4  &&   <a
          className="btn btn-primary mx-auto mt-2 btn-sm"
           href={`${weburl}user-invoice/${id}/${index}`} target='blank'
        >
          <i className="ri-file-download-fill"></i>  
        </a> }

        </td>
    </tr>
    ))
  ) : (
    <tr>
      <td colSpan="8" className="text-center">No Received Added</td>
    </tr>
  )}
</tbody>
</table>
</div>

{AddReceived.length > 0 && (
<div className='col-md-4 ms-auto'>

<table className="table table-bordered">
  <tbody>
    
    <tr>
      <th>Final Total:</th>
      <td><strong>₹ {AddReceived.reduce((acc, data) => acc + parseFloat(data.amount || 0), 0).toFixed(2)} </strong></td>
    </tr>
  </tbody>
</table>

</div>
)}

</div>
 
<div className={`col-md-12 my-4 ${formData.order === 4 && 'd-none'}`}>
<div className='d-flex justify-content-between'>
<h4> Security Return Details
</h4>
<button className="btn btn-primary btn-sm w-auto" data-bs-toggle="modal" data-bs-target="#modal-Return"  >Add Security Return</button>
</div>
<hr/>

<div className='overflow-auto'>
<table className="table table-bordered mt-3">
<thead>
  <tr>
  <th>#</th>
     <th>Date</th>
     <th>Amount INR	</th>
     <th>Payment Method	</th>
    <th> Transaction Id </th>
    <th> Comment </th>
    <th> Action </th>
  </tr>
</thead>
<tbody>
  {AddReturn.length > 0 ? (
    AddReturn.map((rental, index) => (
      <tr key={index}>
      <td>{index + 1}</td>
       <td>{rental.method === 'Cheque' ? rental.chequeDate : rental.date}</td>
        <td>{rental.method === 'Cheque' ? rental.chequeAmount : rental.amount }</td>
        <td>{rental.method}</td>
       <td  >{rental.transaction !== '' ? rental.transaction : 'NA' }</td>
       <td style={{Width:80,maxWidth:80}} > <p  style={{
  maxWidth: '80px',
  whiteSpace: 'break-spaces',
  WebkitLineClamp: 2,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  WebkitBoxOrient: 'vertical',
  display: '-webkit-box',
  padding:'0px',
}} >{rental.comment }
    </p> 
       </td>
      <td style={{Width:80,maxWidth:80}} > 
      <button
          className="btn btn-primary btn-sm me-2"
          onClick={() => handleEditReturn(index)} data-bs-toggle="modal" data-bs-target="#modal-edit-rental"
        >
          <i className="ri-pencil-fill"></i>  
        </button>
          <button
          className="btn btn-danger btn-sm"
          onClick={() => handleRemoveReturn(index)}
        >
          <i className="ri-delete-bin-line"></i>  
        </button>
        </td>
    </tr>
    ))
  ) : (
    <tr>
      <td colSpan="8" className="text-center">No Return Added</td>
    </tr>
  )}
</tbody>
</table>
</div>

{AddReturn.length > 0 && (
<div className='col-md-4 ms-auto'>

<table className="table table-bordered">
  <tbody>
    
    <tr>
      <th>Final Total:</th>
      <td><strong>₹ {AddReturn.reduce((acc, data) => acc + parseFloat(data.amount || 0), 0).toFixed(2)} </strong></td>
    </tr>
  </tbody>
</table>

</div>
)}

</div>
</>
}
<div className='col-md-12 my-4'>
<div className='d-flex justify-content-between'>
<h4>History
</h4>
 </div>
<hr/>

<div className='overflow-auto'>
<table className="table table-bordered mt-3">
<thead>
  <tr>
    <th>#</th>
     <th>Date</th>
    <th>Time</th>
    <th>User details</th>
    <th> Changes </th>
    <th> Commnent </th>
 
  </tr>
</thead>
<tbody>
  {addHistory.length > 0 ? (
    addHistory.map((data, index) => (
      <tr key={index}>
        <td>{index + 1}</td>
         <td>{data.date}</td>
         <td>{data.time}</td>
         <td>Username: {data.name}  
         </td>
          <td>{data.changes}</td>
         <td>{data.comment }</td>
          
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="8" className="text-center">No History Found</td>
    </tr>
  )}
</tbody>
</table>
</div>
 

</div>


<div className="col-12">

{!IsLoading ? (

<button className="btn btn-secondary" type="button" onClick={submitData} >
  Update Order
</button>
) : (

<button class="btn btn-secondary btn-sm" type="button" disabled>
  <span class="ms-1">Loading...</span>
  <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
</button>

)}


</div>



    </div>

</div>
 
 : <div className='h-100 vh-100 d-flex justify-content-center align-items-center'>
  <div class="spinner-border" role="status" style={{width:100,height:100}}></div>
 </div>
}


      
    </>
  )
}

export default OrderEdit